"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helper_1 = require("./helper");
var STUDENT_INFORMATION = {
    title: "Enrollment Packet Information",
    description: "Fill out the fields below exactly as you would like them to appear on the forms. Please note, if there are other fields in each form that you want typed, forms can be edited directly prior to printing.",
    footer: {
        left: "",
        right: "Packet Vs. 4.5 05/24/2023"
    }
};
exports.STUDENT_INFORMATION = STUDENT_INFORMATION;
var STUDENT_INFORMATION_4_6 = {
    title: "Enrollment Packet Information",
    description: "Fill out the fields below exactly as you would like them to appear on the forms. Please note, if there are other fields in each form that you want typed, forms can be edited directly prior to printing.",
    footer: {
        left: "",
        right: "Packet Vs. 4.6 15.2026"
    }
};
exports.STUDENT_INFORMATION_4_6 = STUDENT_INFORMATION_4_6;
var STUDENT_CHECKLIST = {
    title: "Student File Checklist",
    description: "",
    sections: {
        section1: {
            title: "Section 1",
            description: "",
            items: [
                {
                    label: "Student File Checklist"
                }
            ]
        },
        section2: {
            title: "Section 2",
            description: "",
            items: [
                {
                    label: "Completed Enrollment Agreement"
                },
                {
                    label: "Copy of Acceptance Letter"
                },
                {
                    label: "Copy of High School Transcript, GED, or Record of ATB Passing Scores"
                },
                {
                    label: "Introductory Period Notification"
                },
                {
                    label: "ATB/ECPP Disclosure (as applicable)"
                },
                {
                    label: "Student Arbitration Agreement"
                },
                {
                    label: "Transcript Request (as applicable)"
                },
                {
                    label: "Request for Transfer Credits Form (Attachments for above form can include JST, College, any transcript evaluated for credit)"
                }
            ]
        },
        section3: {
            title: "Section 3",
            description: "",
            items: [
                {
                    label: "FERPA Release & Emergency Contact"
                },
                {
                    label: "FERPA Disclosure Record"
                },
                {
                    label: "Disclosure Packet Acknowledgement(ASR, Drug & Alcohol, FERPA, & Consumer Right-to-Know, Test-Out, Student Dress Code, Class Schedule)"
                },
                {
                    label: "Student and Graduate Media Release"
                },
                {
                    label: "Authorization to Release Information"
                },
                {
                    label: "Criminal Conviction and Screening"
                },
                {
                    label: "Salary and Employment Statement"
                }
            ]
        },
        section4: {
            title: "Section 4",
            description: "",
            items: [
                {
                    label: "Copy of Official Government ID"
                },
                {
                    label: "Institutional Application Form"
                },
                {
                    label: "Student Profile Form"
                },
                {
                    label: "Distance Learning Assessment"
                }
            ]
        },
        section5: {
            title: "Section 5",
            description: "Student Forms (as applicable can include but not limited):",
            items: [
                {
                    label: "Student Support Plans"
                },
                {
                    label: "Grade/Class Schedule Changes"
                }
            ]
        },
        section6: {
            title: "Section 6",
            description: "",
            items: [
                {
                    label: "Final Transcripts/Grad Forms"
                },
                {
                    label: "Extern Packet/Immunizations"
                }
            ]
        }
    },
    exitDates: {
        title: "Exit Dates (as applicable)",
        dates: {
            intro: "Introductory Period Exit Date",
            drops: "Drop Dates",
            graduation: "Graduation Date",
            loa: "LOA Dates",
            to: "TO"
        }
    },
    enrollmentAdmission: {
        initials: "Enrollment Packet Complete Admissions Rep Initials",
        file: "File Complete Registrar Initials",
        completed: "Date Completed"
    },
    footer: {
        left: "",
        right: "Vs. 2.5 11/08/2021"
    }
};
exports.STUDENT_CHECKLIST = STUDENT_CHECKLIST;
var STUDENT_CHECKLIST_4_6 = {
    title: "Student File Checklist",
    description: "",
    sections: {
        section1: {
            title: "Section 1",
            description: "",
            items: [
                {
                    label: "Student File Checklist"
                }
            ]
        },
        section2: {
            title: "Section 2",
            description: "",
            items: [
                {
                    label: "Completed Enrollment Agreement"
                },
                {
                    label: "Copy of Acceptance Letter"
                },
                {
                    label: "Copy of High School Transcript, GED, or Record of ATB Passing Scores"
                },
                {
                    label: "Introductory Period Notification"
                },
                {
                    label: "ATB/ECPP Disclosure (as applicable)"
                },
                {
                    label: "Student Arbitration Agreement"
                },
                {
                    label: "Transcript Request (as applicable)"
                },
                {
                    label: "Request for Transfer Credits Form (Attachments for above form can include JST, College, any transcript evaluated for credit)"
                }
            ]
        },
        section3: {
            title: "Section 3",
            description: "",
            items: [
                {
                    label: "FERPA Release & Emergency Contact"
                },
                {
                    label: "Disclosure Packet Acknowledgement(ASR, Drug & Alcohol, FERPA, & Consumer Right-to-Know, Student Dress Code, Class Schedule)"
                },
                {
                    label: "Authorization to Release Information"
                },
                {
                    label: "Criminal Conviction and Screening"
                },
                {
                    label: "Salary and Employment Statement"
                }
            ]
        },
        section4: {
            title: "Section 4",
            description: "",
            items: [
                {
                    label: "Copy of Official Government ID"
                },
                {
                    label: "Institutional Application Form"
                },
                {
                    label: "Student Profile Form"
                },
                {
                    label: "Distance Learning Assessment"
                }
            ]
        },
        section5: {
            title: "Section 5",
            description: "Student Forms (as applicable can include but not limited):",
            items: [
                {
                    label: "Student Support Plans"
                },
                {
                    label: "Grade/Class Schedule Changes"
                }
            ]
        },
        section6: {
            title: "Section 6",
            description: "",
            items: [
                {
                    label: "Final Transcripts/Grad Forms"
                },
                {
                    label: "Extern Packet/Immunizations"
                }
            ]
        }
    },
    exitDates: {
        title: "Exit Dates (as applicable)",
        dates: {
            intro: "Introductory Period Exit Date",
            drops: "Drop Dates",
            graduation: "Graduation Date",
            loa: "LOA Dates",
            to: "TO"
        }
    },
    enrollmentAdmission: {
        initials: "Enrollment Packet Complete Admissions Rep Initials",
        file: "File Complete Registrar Initials",
        completed: "Date Completed"
    },
    footer: {
        left: "",
        right: "Vs. 2.6 1/15/2026"
    }
};
exports.STUDENT_CHECKLIST_4_6 = STUDENT_CHECKLIST_4_6;
var STUDENT_INTRODUCTORY_PERIOD = {
    title: "Introductory Period (IP) Notification",
    description: "The Introductory Period (IP) is designed to provide students an opportunity to experience IntelliTec College`s curriculum, faculty, learning environment, and student services. During this period, the student will not incur program tuition charges although book, uniform, and tool charges may apply",
    condition: {
        title: "Introductory Period Conditions",
        backendClass: "form-user-student form-required",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "equipment",
                checked: false,
                descriptions: [
                    "I understand that I will be issued all necessary textbooks, tools, electronic devices, and/or equipment during the introductory period."
                ]
            },
            {
                title: "withdraw",
                checked: false,
                descriptions: [
                    'If I decide to withdraw during or at the end of the introductory period, textbooks, tools, electronic devices, and/or equipment can be returned to the Business Office if they are in "as new" condition, in original packaging, and no charges will be assessed. Cost for all returned items not in "as new" condition, as well as any items not returned will become my responsibility and may be reported for billing and collection'
                ]
            },
            {
                title: "enrollment",
                checked: false,
                descriptions: [
                    "I understand that if I wish to cease enrollment during or just prior to the end of the Introductory Period, I must do so in writing to the college and I must see my Admissions Representative."
                ]
            },
            {
                title: "scheduled",
                checked: false,
                descriptions: [
                    "I understand that attending class on the last scheduled class day of the first week indicates my reaffirmation",
                    " I will be an active student, and will be charged according to my enrollment agreement. If I fail to return to class after the introductory period, I will be automatically withdrawn."
                ]
            },
            {
                title: "financial",
                checked: false,
                descriptions: [
                    "I understand that I will not incur tuition charges and am not eligible for federal financial aid disbursements until the Last class day of the 1st week, which is the end of the introductory period."
                ]
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 2.4 12/08/2022"
    }
};
exports.STUDENT_INTRODUCTORY_PERIOD = STUDENT_INTRODUCTORY_PERIOD;
var STUDENT_INTRODUCTORY_PERIOD_4_6 = {
    title: "Introductory Period (IP) Notification",
    description: "The Introductory Period (IP) is designed to provide students an opportunity to experience IntelliTec College`s curriculum, faculty, learning environment, and student services. During this period, the student will not incur program tuition charges although book, uniform, and tool charges may apply",
    condition: {
        title: "Introductory Period Conditions",
        backendClass: "form-user-student form-required",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "equipment",
                checked: false,
                descriptions: [
                    "I understand that I will be issued all necessary textbooks, tools, electronic devices, and/or equipment during the introductory period."
                ]
            },
            {
                title: "withdraw",
                checked: false,
                descriptions: [
                    'If I decide to withdraw during or at the end of the introductory period, textbooks, tools, electronic devices, and/or equipment can be returned to the Business Office if they are in "as new" condition, in original packaging, and no charges will be assessed. Cost for all returned items not in "as new" condition, as well as any items not returned will become my responsibility and may be reported for billing and collection'
                ]
            },
            {
                title: "enrollment",
                checked: false,
                descriptions: [
                    "I understand that if I wish to cease enrollment during or just prior to the end of the Introductory Period, I must do so in writing to the college and I must see my Admissions Representative."
                ]
            },
            {
                title: "scheduled",
                checked: false,
                descriptions: [
                    "I understand that if I do not submit a written request to withdraw during the first week of class,",
                    " I will be considered an active student and will be charged in accordance with my enrollment agreement."
                ]
            },
            {
                title: "financial",
                checked: false,
                descriptions: [
                    "I understand that I will not incur tuition charges and am not eligible for federal financial aid disbursements until the Last class day of the 1st week, which is the end of the introductory period."
                ]
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 2.5 1/15/2026"
    }
};
exports.STUDENT_INTRODUCTORY_PERIOD_4_6 = STUDENT_INTRODUCTORY_PERIOD_4_6;
var STUDENT_ABILITY_BENEFIT = {
    title: "Ability to Benefit – Eligible Career Pathway (ECPP) Disclosure",
    description: "An ECPP must contain two components: A Title IV eligible postsecondary program component and a component that enables a student to attain a high school diploma or recognized equivalent. IntelliTec has designed ECPP students to be concurrently enrolled in one of IntelliTec’s Title IV eligible vocational programs and an Adult Education Program offered through C4L Academy.",
    condition: {
        title: "ECPP Acknowledgments",
        backendClass: "form-user-student form-required",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "Education",
                checked: false,
                descriptions: [
                    "Enrolling in the Adult Education program is required and participation is expected throughout the course of your vocational program at the College."
                ]
            },
            {
                title: "College",
                checked: false,
                descriptions: [
                    "I understand that the College will facilitate, through an Adult Education service provider, the requirements needed to obtain a high school diploma or its equivalent."
                ]
            },
            {
                title: "program",
                checked: false,
                descriptions: [
                    "I will be concurrently enrolled in the Adult Education provider’s program and the Vocational program at the College."
                ]
            },
            {
                title: "diploma",
                checked: false,
                descriptions: [
                    "The College does not guarantee that I will receive a high school diploma or its equivalent. Completing the vocational portion of the ECPP program is not a requirement for receipt of my high school diploma or its equivalent."
                ]
            },
            {
                title: "vocational",
                checked: false,
                descriptions: [
                    "I understand by signing below, that if I successfully complete the adult education component of the program prior to completing the vocational component of the program, I will not receive the high school diploma from IntelliTec College until I graduate from the vocational program."
                ]
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 1.0 02/28/2020"
    }
};
exports.STUDENT_ABILITY_BENEFIT = STUDENT_ABILITY_BENEFIT;
var STUDENT_ABILITY_BENEFIT_4_6 = {
    title: "Ability to Benefit – Eligible Career Pathway (ECPP) Disclosure",
    description: "An ECPP must contain two components: A Title IV eligible postsecondary program component and a component that enables a student to attain a high school diploma or recognized equivalent. IntelliTec has designed ECPP students to be concurrently enrolled in one of IntelliTec’s Title IV eligible vocational programs and an Adult Education Program offered through C4L Academy.",
    condition: {
        title: "ECPP Acknowledgments",
        backendClass: "form-user-student form-required",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "Education",
                checked: false,
                descriptions: [
                    "Enrolling in the Adult Education program is required and participation is expected throughout the course of your vocational program at the College."
                ]
            },
            {
                title: "College",
                checked: false,
                descriptions: [
                    "I understand that the College will facilitate, through an Adult Education service provider, the requirements needed to obtain a high school diploma or its equivalent."
                ]
            },
            {
                title: "program",
                checked: false,
                descriptions: [
                    "I will be concurrently enrolled in the Adult Education provider’s program and the Vocational program at the College."
                ]
            },
            {
                title: "diploma",
                checked: false,
                descriptions: [
                    "The College does not guarantee that I will receive a high school diploma or its equivalent. Completing the vocational portion of the ECPP program is not a requirement for receipt of my high school diploma or its equivalent."
                ]
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 1.1 01/15/2026"
    }
};
exports.STUDENT_ABILITY_BENEFIT_4_6 = STUDENT_ABILITY_BENEFIT_4_6;
var STUDENT_ABILITY_BENEFIT_EXTRA = {
    title: "Cosmetology and Massage Therapy Disclosure",
    subTitle: "Ability to Benefit – Eligible Career Pathway (ECPP) Disclosure",
    description: "An ECPP must contain two components: A Title IV eligible postsecondary program component and a component that enables a student to attain a high school diploma or recognized equivalent. IntelliTec has designed ECPP students to be concurrently enrolled in one of IntelliTec’s Title IV eligible vocational programs and an Adult Education Program offered through C4L Academy.",
    condition: {
        title: "ECPP Acknowledgments",
        backendClass: "form-user-student form-required",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "College",
                checked: false,
                descriptions: [
                    "I understand that if I do not have a high school diploma or equivalent and I do not complete the Adult Education Program offered through C4L Academy I will not be eligible to sit for the Cosmetologist State Board Exam."
                ]
            },
            {
                title: "vocational",
                checked: false,
                descriptions: [
                    "I understand that if I do not have a high school diploma or equivalent and I do not complete the Adult Education Program offered through C4L Academy I will not be eligible to obtain licensure with the New Mexico Massage Therapy Board."
                ]
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 2.0 12/07/2022"
    }
};
exports.STUDENT_ABILITY_BENEFIT_EXTRA = STUDENT_ABILITY_BENEFIT_EXTRA;
var STUDENT_ABILITY_BENEFIT_EXTRA_4_6 = {
    title: "Cosmetology and Massage Therapy Disclosure",
    subTitle: "Ability to Benefit – Eligible Career Pathway (ECPP) Disclosure",
    description: "An ECPP must contain two components: A Title IV eligible postsecondary program component and a component that enables a student to attain a high school diploma or recognized equivalent. IntelliTec has designed ECPP students to be concurrently enrolled in one of IntelliTec’s Title IV eligible vocational programs and an Adult Education Program offered through C4L Academy.",
    condition: {
        title: "ECPP Acknowledgments",
        backendClass: "form-user-student form-required",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "College",
                checked: false,
                descriptions: [
                    "I understand that if I do not have a high school diploma or equivalent and I do not complete the Adult Education Program offered through C4L Academy I will not be eligible to sit for the Cosmetologist State Board Exam."
                ]
            },
            {
                title: "vocational",
                checked: false,
                descriptions: [
                    "I understand that if I do not have a high school diploma or equivalent and I do not complete the Adult Education Program offered through C4L Academy I will not be eligible to obtain licensure with the Massage Therapy Board."
                ]
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 2.1 01/15/2026"
    }
};
exports.STUDENT_ABILITY_BENEFIT_EXTRA_4_6 = STUDENT_ABILITY_BENEFIT_EXTRA_4_6;
var STUDENT_ARBITRATION_AGREEMENT = {
    title: "STUDENT ARBITRATION AGREEMENT",
    description: {
        first: 'The Parties to this Student Arbitration Agreement("Agreement") are',
        seccond: '("Student") and IntelliTec Colleges ("College").'
    },
    aggrement: {
        title: "",
        conditions: [
            {
                subtitle: "Claims Subject to Arbitration.",
                description: "Any and all disputes or claims between the Parties or any of College's officers, directors, employees, or agents, whether arising in tort, contract, statute, or otherwise and relating in any manner to Student's relationship with College, shall be resolved through binding arbitration pursuant to this agreement, including any dispute regarding the enforceability, scope, or validity of this Agreement. As exceptions to this provision, the Parties may file a lawsuit within the jurisdiction of a Colorado small claims court and Student may file a complaint or charge with any administrative agency which has independent jurisdiction to investigate such a claim."
            },
            {
                subtitle: "Governing Law and Rules.",
                description: "Arbitration under this Agreement shall be governed by the Federal Arbitration Act and conducted under the American Arbitration Association's Consumer Arbitration Rules (\"AAA Rules\")."
            },
            {
                subtitle: "Notice of Arbitration",
                description: "Arbitration under this Agreement shall be initiated by submitting a written demand to the other Party. Student shall submit any demand to Chief Executive Officer, 2504 East Pikes Peak Ave, Ste. 305 Colorado Springs, CO 80909."
            },
            {
                subtitle: "Arbitration Hearing.",
                description: "Arbitration pursuant to this Agreement shall be conducted by one arbitrator who may be agreed upon by the Parties or, in the event the Parties cannot agree, as selected through or appointed by AAA. The hearing shall take place in the country in which the College campus attended by the Student is located. The decision of the Arbitrator shall be final and binding. The Arbitrator shall have authority to award any relief that would be available in a court on the claim or claims asserted."
            },
            {
                subtitle: "No Class or Collective Action.",
                description: "We agree that neither we nor anyone else who later becomes a party to this agreement will use this agreement to stop you from being part of a class action lawsuit in court. You may file a class action lawsuit in court or you may be a member of a class action lawsuit even if you do not file it. This provision applies only to class action claims concerning our acts or omissions regarding the making of the Federal Direct Loan or the provision by us of educational services for which the Federal Direct Loan was obtained. We agree that only the court is to decide whether a claim asserted in the lawsuit is a claim regarding the making of the Federal Direct Loan or the provision of educational services for which the loan was obtained."
            },
            {
                subtitle: "Arbitration Fees and Costs.",
                description: "Each party will bear the expense of its own attorneys, experts, and witnesses, regardless of which party prevails, unless applicable law gives a right to recover any of those expenses from the other party. Responsibility to pay administrative and filing fees, arbitrator compensation or other costs related to the arbitration proceedings conducted by the AAA shall be according to the AAA Rules in effect at the time of commencement of the Arbitration."
            },
            {
                subtitle: "Confidentiality.",
                description: "Except as may be required by law, neither a Party nor an Arbitrator may disclose the existence, content of any arbitration conducted pursuant to this Agreement without the written consent of both parties."
            },
            {
                subtitle: "Severability.",
                description: "If any provision of this Agreement (other than the provisions of paragraph 5 above), is held illegal or unenforceable in a judicial proceeding or arbitration, such provision shall be severed and inoperative, but the\n                remainder of the provisions shall remain operative and binding upon the Parties."
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 1.2 05/14/2019"
    }
};
exports.STUDENT_ARBITRATION_AGREEMENT = STUDENT_ARBITRATION_AGREEMENT;
var STUDENT_ARBITRATION_AGREEMENT_4_6 = {
    title: "STUDENT ARBITRATION AGREEMENT",
    description: {
        first: 'The Parties to this Student Arbitration Agreement("Agreement") are',
        seccond: '("Student") and IntelliTec Colleges ("College").'
    },
    aggrement: {
        title: "",
        conditions: [
            {
                subtitle: "Claims Subject to Arbitration.",
                description: "Any and all disputes or claims between the Parties or any of College's officers, directors, employees, or agents, whether arising in tort, contract, statute, or otherwise and relating in any manner to Student's relationship with College, shall be resolved through binding arbitration pursuant to this agreement, including any dispute regarding the enforceability, scope, or validity of this Agreement. As exceptions to this provision, the Parties may file a lawsuit within the jurisdiction of a Colorado small claims court and Student may file a complaint or charge with any administrative agency which has independent jurisdiction to investigate such a claim."
            },
            {
                subtitle: "Governing Law and Rules.",
                description: "Arbitration under this Agreement shall be governed by the Federal Arbitration Act and conducted under the American Arbitration Association's Consumer Arbitration Rules (\"AAA Rules\")."
            },
            {
                subtitle: "Notice of Arbitration",
                description: "Arbitration under this Agreement shall be initiated by submitting a written demand to the other Party. Student shall submit any demand to VP of Operations, 2504 East Pikes Peak Ave, Ste. 305 Colorado Springs, CO 80909."
            },
            {
                subtitle: "Arbitration Hearing.",
                description: "Arbitration pursuant to this Agreement shall be conducted by one arbitrator who may be agreed upon by the Parties or, in the event the Parties cannot agree, as selected through or appointed by AAA. The hearing shall take place in the country in which the College campus attended by the Student is located. The decision of the Arbitrator shall be final and binding. The Arbitrator shall have authority to award any relief that would be available in a court on the claim or claims asserted."
            },
            {
                subtitle: "No Class or Collective Action.",
                description: "We agree that neither we nor anyone else who later becomes a party to this agreement will use this agreement to stop you from being part of a class action lawsuit in court. You may file a class action lawsuit in court or you may be a member of a class action lawsuit even if you do not file it. This provision applies only to class action claims concerning our acts or omissions regarding the making of the Federal Direct Loan or the provision by us of educational services for which the Federal Direct Loan was obtained. We agree that only the court is to decide whether a claim asserted in the lawsuit is a claim regarding the making of the Federal Direct Loan or the provision of educational services for which the loan was obtained."
            },
            {
                subtitle: "Arbitration Fees and Costs.",
                description: "Each party will bear the expense of its own attorneys, experts, and witnesses, regardless of which party prevails, unless applicable law gives a right to recover any of those expenses from the other party. Responsibility to pay administrative and filing fees, arbitrator compensation or other costs related to the arbitration proceedings conducted by the AAA shall be according to the AAA Rules in effect at the time of commencement of the Arbitration."
            },
            {
                subtitle: "Confidentiality.",
                description: "Except as may be required by law, neither a Party nor an Arbitrator may disclose the existence, content of any arbitration conducted pursuant to this Agreement without the written consent of both parties."
            },
            {
                subtitle: "Severability.",
                description: "If any provision of this Agreement (other than the provisions of paragraph 5 above), is held illegal or unenforceable in a judicial proceeding or arbitration, such provision shall be severed and inoperative, but the\n                remainder of the provisions shall remain operative and binding upon the Parties."
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 1.3 01/15/2026"
    }
};
exports.STUDENT_ARBITRATION_AGREEMENT_4_6 = STUDENT_ARBITRATION_AGREEMENT_4_6;
var STUDENT_LICENCE_AGREEMENT = {
    title: "",
    description: {
        first: "THIS AGREEMENT LIMITS CERTAIN RIGHTS, INCLUDING THE RIGHT TO MAINTAIN A COURT ACTION,\n        THE RIGHT TO A JURY TRIAL, THE RIGHT TO PARTICIPATE IN DISCOVERY (EXCEPT AS PROVIDED FOR\n        IN THE AAA RULES), AND THE RIGHT TO PARTICIPATE IN ANY FORM OF CLASS OR JOINT CLAIM. OTHER\n        RIGHTS THAT STUDENT OR COLLEGE MAY HAVE IN COURT MAY ALSO NOT BE AVAILABLE IN\n        ARBITRATION.",
        seccond: "BY SIGNING BELOW (AND INITIALING ABOVE), STUDENT CONFIRMS HE/SHE HAS READ THE TERMS OF\n        THIS AGREEMENT, HAS HAD TIME TO CONSIDER ITS TERMS (INCLUDING AN OPPORTUNITY TO\n        CONSULT WITH AN ATTORNEY AT HIS/HER CHOOSING AND EXPENSE), AND AGREES TO ALL OF THE\n        TERMS CONTAINED IN IT. IN ADDITION, STUDENT SHALL HAVE 2 WEEKS FROM THE DATE HE/SHE\n        SIGNS THE ENROLLMENT AGREEMENT AND THIS AGREEMENT TO REJECT THEM IN WRITING."
    },
    footer: {
        left: "",
        right: "Vs. 1.2 05/14/2019"
    }
};
exports.STUDENT_LICENCE_AGREEMENT = STUDENT_LICENCE_AGREEMENT;
var STUDENT_LICENCE_AGREEMENT_4_6 = {
    title: "",
    description: {
        first: "THIS AGREEMENT LIMITS CERTAIN RIGHTS, INCLUDING THE RIGHT TO MAINTAIN A COURT ACTION,\n        THE RIGHT TO A JURY TRIAL, THE RIGHT TO PARTICIPATE IN DISCOVERY (EXCEPT AS PROVIDED FOR\n        IN THE AAA RULES), AND THE RIGHT TO PARTICIPATE IN ANY FORM OF CLASS OR JOINT CLAIM. OTHER\n        RIGHTS THAT STUDENT OR COLLEGE MAY HAVE IN COURT MAY ALSO NOT BE AVAILABLE IN\n        ARBITRATION.",
        seccond: "BY SIGNING BELOW (AND INITIALING ABOVE), STUDENT CONFIRMS HE/SHE HAS READ THE TERMS OF\n        THIS AGREEMENT, HAS HAD TIME TO CONSIDER ITS TERMS (INCLUDING AN OPPORTUNITY TO\n        CONSULT WITH AN ATTORNEY AT HIS/HER CHOOSING AND EXPENSE), AND AGREES TO ALL OF THE\n        TERMS CONTAINED IN IT. IN ADDITION, STUDENT SHALL HAVE 2 WEEKS FROM THE DATE HE/SHE\n        SIGNS THE ENROLLMENT AGREEMENT AND THIS AGREEMENT TO REJECT THEM IN WRITING."
    },
    footer: {
        left: "",
        right: "Vs. 1.3 01/15/2026"
    }
};
exports.STUDENT_LICENCE_AGREEMENT_4_6 = STUDENT_LICENCE_AGREEMENT_4_6;
var STUDENT_TRANSCRIPT_REQUEST = {
    title: "Transcript Request",
    title2: "Authorization for Release of School/College/Testing Center Records",
    description: "Please return Top Portion with Transcript -- Detach and retain Bottom Portion for your Records",
    fee: {
        highSchool: {
            title: "High School Transcript",
            placeholder: "Enter your high school fee",
            description: "Fee",
            identifier: "page7_fee_1"
        },
        college: {
            title: "College Transcript",
            placeholder: "Enter your college fee",
            description: "Fee",
            identifier: "page7_fee_2"
        },
        ged: {
            title: "GED Testing Results",
            placeholder: "Enter your ged fee",
            description: "Fee",
            identifier: "page7_fee_3"
        },
        warning: "Transcript fee, if required, will be paid by receiving Institution upon receipt of transcript and/or notification of charges."
    },
    transcripts: {
        colorado: {
            title: "IntelliTec College Colorado Springs",
            address: "2315 E. Pikes Peak Ave",
            city: "Colorado Springs, CO 80909",
            attn: "Registrar",
            fax: "719.213.2306",
            identifier: "page7_transcript_address_1"
        },
        grandJunction: {
            title: "IntelliTec College Grand Junction",
            address: "772 Horizon Drive",
            city: "Grand Junction, CO 81506",
            attn: "Registrar",
            fax: "970.797.1677",
            identifier: "page7_transcript_address_2"
        },
        pueblo: {
            title: "IntelliTec College Pueblo",
            address: "3673 Parker Blvd Suite 250",
            city: "Pueblo, CO 81008",
            attn: "Registrar",
            fax: "719.543.1056",
            identifier: "page7_transcript_address_3"
        },
        abq: {
            title: "IntelliTec College ABQ",
            address: "4575 San Mateo Blvd. NE Suite K",
            city: "Albuquerque, NM 87109",
            attn: "Registrar",
            fax: "505.214.5045",
            identifier: "page7_transcript_address_4"
        }
    },
    footer: {
        left: "",
        right: "Vs. 4.1 05/24/2023"
    },
    remove: "************************************************************************************************"
};
exports.STUDENT_TRANSCRIPT_REQUEST = STUDENT_TRANSCRIPT_REQUEST;
var STUDENT_TRANSCRIPT_REQUEST_4_6 = {
    title: "Transcript Request",
    title2: "Authorization for Release of School/College/Testing Center Records",
    description: "Please return Top Portion with Transcript -- Detach and retain Bottom Portion for your Records",
    fee: {
        highSchool: {
            title: "High School Transcript",
            placeholder: "Enter your high school fee",
            description: "Fee",
            identifier: "page7_fee_1"
        },
        college: {
            title: "College Transcript",
            placeholder: "Enter your college fee",
            description: "Fee",
            identifier: "page7_fee_2"
        },
        ged: {
            title: "GED Testing Results",
            placeholder: "Enter your ged fee",
            description: "Fee",
            identifier: "page7_fee_3"
        },
        warning: "Transcript fee, if required, will be paid by receiving Institution upon receipt of transcript and/or notification of charges."
    },
    transcripts: {
        colorado: {
            title: "IntelliTec College Colorado Springs",
            address: "2315 E. Pikes Peak Ave",
            city: "Colorado Springs, CO 80909",
            attn: "Registrar",
            fax: "719.213.2306",
            identifier: "page7_transcript_address_1"
        },
        grandJunction: {
            title: "IntelliTec College Grand Junction",
            address: "772 Horizon Drive",
            city: "Grand Junction, CO 81506",
            attn: "Registrar",
            fax: "970.797.1677",
            identifier: "page7_transcript_address_2"
        },
        pueblo: {
            title: "IntelliTec College Pueblo",
            address: "3673 Parker Blvd Suite 250",
            city: "Pueblo, CO 81008",
            attn: "Registrar",
            fax: "719.543.1056",
            identifier: "page7_transcript_address_3"
        },
        abq: {
            title: "IntelliTec College ABQ",
            address: "4575 San Mateo Blvd. NE Suite K",
            city: "Albuquerque, NM 87109",
            attn: "Registrar",
            fax: "505.214.5045",
            identifier: "page7_transcript_address_4"
        }
    },
    footer: {
        left: "",
        right: "Vs. 4.2 01/15/2026"
    },
    remove: "************************************************************************************************"
};
exports.STUDENT_TRANSCRIPT_REQUEST_4_6 = STUDENT_TRANSCRIPT_REQUEST_4_6;
var STUDENT_REQUEST_TRANSFER = {
    title: "Request for Transfer Credit(s)",
    description: "I understand that I may request the transfer of prior credits and information regarding this process is available in the IntelliTec College Student Catalog.",
    creditsTrasnsfer: [1, 2, 3, 4, 5, 6],
    creditsGranted: [1, 2, 3, 4, 5],
    creditsTrasnsfer2: [1, 2, 3, 4, 5, 6, 7, 8],
    creditsGranted2: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    condition: {
        title: "Please Initial the Following Statements",
        backendClass: "form-user-student form-required",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "transfer1",
                checked: false,
                descriptions: [
                    "I understand that receiving transfer credit(s) may result in schedule changes due to classes being unavailable."
                ]
            },
            {
                title: "transfer2",
                checked: false,
                descriptions: [
                    "I understand that receiving transfer credit(s) can change my financial aid eligibility and may result in additional cash payments while in school."
                ]
            },
            {
                title: "transfer3",
                checked: false,
                descriptions: [
                    "I understand that this is a request for evaluation and does not constitute acceptance of transfer credit(s) by IntelliTec College."
                ]
            },
            {
                title: "transfer4",
                checked: false,
                descriptions: [
                    "I understand that I must provide an official transcript for evaluation."
                ]
            },
            {
                title: "transfer5",
                checked: false,
                descriptions: [
                    "I understand that I must provide official transcript(s) as soon as possible but no later than six weeks from the start of classes or transfer credit(s) may not be granted."
                ]
            }
        ]
    },
    footer: {
        left: "",
        right: "cc: Program Supervisor, FA and Business Office Vs. 3.1 12/9/2019"
    },
    continued: "Page 2 (continued – Request for Transfer Credit(s))"
};
exports.STUDENT_REQUEST_TRANSFER = STUDENT_REQUEST_TRANSFER;
var STUDENT_FERPA_RELEASE_FORM = {
    title: "FERPA RELEASE FORM/EMERGENCY CONTACT",
    subtitle1: "FERPA Release Consent",
    subtitle2: "Emergency Contact",
    description: "In compliance with the Family Educational Rights and Privacy Act (FERPA) of 1974 as amended, IntelliTec Colleges will not release student information beyond the college\u2019s directory information to any thirdparty without written permission by the student. IntelliTec Colleges\n    reserves the right to review and respond to requests for release of education records on a case-by-case basis.",
    description2: "I understand that (1) I have the right not to consent to the release of my education records; (2) that I have the right to inspect any\n    written records released pursuant to this consent (3) and that this consent will remain in effect until revoked by me, in writing and\n    delivered to the Registrar at my Intellitec College campus. The revocation of consent shall not affect disclosures made by IntelliTec prior\n    to the receipt of any such written revocation. The most recently dated form in my file will supersede any previous forms completed.",
    footer: {
        left: "",
        right: "Vs. 1.0 01/29/2020"
    }
};
exports.STUDENT_FERPA_RELEASE_FORM = STUDENT_FERPA_RELEASE_FORM;
var STUDENT_FERPA_RECORD_DISCLOSURE = {
    title: "Record of Disclosure (FERPA)",
    subtitle: "IntelliTec Colleges has disclosed this student’s record under Section 99 of the U.S. Department of Education regulations.",
    description: "**Financial, Financial Aid, Academic, Disciplinary, All records, or other (specify)",
    records: {
        header: [
            {
                label: "#",
                hasTooltip: false
            },
            {
                label: "Name",
                hasTooltip: false
            },
            {
                label: "Affiliation",
                hasTooltip: false
            },
            {
                label: "Purpose",
                hasTooltip: false
            },
            {
                label: "Type of Record**",
                hasTooltip: true,
                description: "**Financial, Financial Aid, Academic, Disciplinary, All records, or other (specify)"
            },
            {
                label: "Date",
                hasTooltip: false
            }
        ],
        rows: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13]
    },
    footer: {
        left: "",
        right: "Vs. 1.1 04/19/2017"
    }
};
exports.STUDENT_FERPA_RECORD_DISCLOSURE = STUDENT_FERPA_RECORD_DISCLOSURE;
var STUDENT_DISCLOSURE_PACKET = {
    title: "Disclosure Packet",
    description: "(Please initial each item, all below policies are in the Disclosure Packet Handout VS 2.0)",
    conditionList1: {
        title: "",
        backendClass: "form-user-student form-required",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "security",
                isDisplayBlock: true,
                descriptions: [
                    "Annual Security Report",
                    "I certify that I have been advised by IntelliTec Colleges of the availability of the Campus Annual Security Report, crime\n                statistics, and the url where I can access the report. I understand that I may request a paper copy from the Campus\n                Registrar at no charge."
                ]
            },
            {
                title: "prevention",
                isDisplayBlock: true,
                separator: true,
                descriptions: [
                    "Drug and Alcohol Abuse Prevention Policy",
                    "I certify that I have been advised of IntelliTec Colleges\u2019 Drug and Alcohol Abuse Prevention policy in accordance with\n                the Education Department General Administrative Regulations (EDGAR) Title 34 Part 86 Drug Prevention and Abuse\n                and Section 120 of Title I of the Higher Education Act of 1965. This policy prohibits, the manufacture; sale, purchase,\n                distribution or other transfer; possession; or being impaired or under the influence, of any controlled substance\n                including alcohol; illegal drugs; legal drugs used or to be used illegally; or medicinal or recreational marijuana."
                ]
            }
        ]
    },
    conditionList2: {
        title: "",
        backendClass: "form-user-student form-required",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "notifications",
                isDisplayBlock: true,
                descriptions: [
                    "Notification of Rights under FERPA (Family Educational Rights & Privacy Act)",
                    "I have received and read a copy of my rights under FERPA. I understand my rights regarding FERPA release of\n                personally identifiable information and the release of Directory information."
                ]
            },
            {
                title: "consumer",
                isDisplayBlock: true,
                descriptions: [
                    "Consumer Right-To-Know",
                    "I have received and read a copy of the Consumer Information form and understand that I can find applicable right-to-\n                know information at <a href=\"https://intellitec.edu/\" rel=\"noreferrer\">www.intellitec.edu</a> under the heading <strong>Consumer Information</strong>."
                ]
            },
            {
                title: "request",
                isDisplayBlock: true,
                descriptions: [
                    "Test-Out Request",
                    "I have received and read a copy of the student Test-Out form and understand that to test out of a course I must request\n                this in writing by submitting the Test-Out form to the Registrar\u2019s office within the first 6 weeks of my program. More\n                information is available on Test-Outs in the Student Catalog."
                ]
            },
            {
                title: "student",
                isDisplayBlock: true,
                descriptions: [
                    "Student Dress Code",
                    "I have been provided a copy of the Student Dress Code Policy, have read the policies, and\n                understand that I must abide by the requirements set forth in it."
                ]
            },
            {
                title: "schedule",
                isDisplayBlock: true,
                descriptions: [
                    "Class Schedule",
                    "I have been provided a copy of my program class times. <div><strong>I acknowledge the above statements, have been provided the corresponding disclosure paperwork, and understand\n                that I can request additional information at any time.</strong></div>"
                ]
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 2.1 02/12/2020"
    }
};
exports.STUDENT_DISCLOSURE_PACKET = STUDENT_DISCLOSURE_PACKET;
var STUDENT_DISCLOSURE_PACKET_4_6 = {
    title: "Disclosure Packet",
    description: "(Please initial each item, all below policies are in the Disclosure Packet Handout and https://intellitec.edu/disclosures/)",
    conditionList1: {
        title: "",
        backendClass: "form-user-student form-required",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "security",
                isDisplayBlock: true,
                descriptions: [
                    "Annual Security Report",
                    "I certify that I have been advised by IntelliTec Colleges of the availability of the Campus Annual Security Report, crime\n                statistics, and the url where I can access the report. I understand that I may request a paper copy from the Campus\n                Registrar at no charge."
                ]
            },
            {
                title: "prevention",
                isDisplayBlock: true,
                separator: true,
                descriptions: [
                    "Drug and Alcohol Abuse Prevention Policy",
                    "I certify that I have been advised of IntelliTec Colleges\u2019 Drug and Alcohol Abuse Prevention policy in accordance with\n                the Education Department General Administrative Regulations (EDGAR) Title 34 Part 86 Drug Prevention and Abuse\n                and Section 120 of Title I of the Higher Education Act of 1965. This policy prohibits, the manufacture; sale, purchase,\n                distribution or other transfer; possession; or being impaired or under the influence, of any controlled substance\n                including alcohol; illegal drugs; legal drugs used or to be used illegally; or medicinal or recreational marijuana."
                ]
            }
        ]
    },
    conditionList2: {
        title: "",
        backendClass: "form-user-student form-required",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "notifications",
                isDisplayBlock: true,
                descriptions: [
                    "Notification of Rights under FERPA (Family Educational Rights & Privacy Act)",
                    "I have received and read a copy of my rights under FERPA. I understand my rights regarding FERPA release of\n                personally identifiable information and the release of Directory information."
                ]
            },
            {
                title: "consumer",
                isDisplayBlock: true,
                descriptions: [
                    "Consumer Right-To-Know",
                    "I have received and read a copy of the Consumer Information form and understand that I can find applicable right-to-\n                know information at <a href=\"https://intellitec.edu/disclosures/\" rel=\"noreferrer\">intellitec.edu/disclosures/</a>."
                ]
            },
            {
                title: "student",
                isDisplayBlock: true,
                descriptions: [
                    "Student Dress Code",
                    "I have been provided a copy of the Student Dress Code Policy, have read the policies, and\n                understand that I must abide by the requirements set forth in it."
                ]
            },
            {
                title: "schedule",
                isDisplayBlock: true,
                descriptions: [
                    "Class Schedule",
                    "I have been provided a copy of my program class times. <div><strong>I acknowledge the above statements, have been provided the corresponding disclosure paperwork, and understand\n                that I can request additional information at any time.</strong></div>"
                ]
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 2.2 01/15/2026"
    }
};
exports.STUDENT_DISCLOSURE_PACKET_4_6 = STUDENT_DISCLOSURE_PACKET_4_6;
var STUDENT_GRADUATE_MEDIA_RELEASE_FORM = {
    title: "Student and Graduate Media Release Form",
    description1: "In consideration of my willingness to appear in photographs and videography (\u201CMedia\u201D) that IntelliTec College\n    may elect to use in print or any other media, or to be quoted concerning comments I have made about my\n    student experience at IntelliTec College, I irrevocably grant to IntelliTec College and its licensees, successors, and\n    assignees the right to use such media or comments and any portion thereof in any manner in external or internal\n    print or digital media, such as newspaper, radio, magazines, websites, TV, social media, newsletters, internal\n    training materials, or posting on college walls without financial payment or compensation.",
    description2: "I acknowledge that IntelliTec College is under no obligation to use any media in which I appear, and I hereby\n    waive any right to inspect the media or quotations or any uses thereof. I further waive any claims that I may\n    have against IntelliTec College and its licensees, successors, and assignees, based upon the above actions or\n    uses, including, without limitation, any claims for invasion of privacy, violation of the right of publicity, libel, and\n    copyright infringement.",
    description3: "In addition, IntelliTec is authorized to use this information internally for informational and promotional\n    purposes.",
    footer: {
        left: "",
        right: "Vs. 2.1 06/07/2018"
    }
};
exports.STUDENT_GRADUATE_MEDIA_RELEASE_FORM = STUDENT_GRADUATE_MEDIA_RELEASE_FORM;
var STUDENT_AUTHORIZATION_INFORMATION = {
    title: "Authorization to Release Information",
    description1: "IntelliTec Colleges (\u201CIntelliTec\u201D) must regularly collect and report on the educational and employment outcomes of our\n    students. Accordingly, I understand it may be necessary for IntelliTec to verify matters that affect career training such as\n    employment status, continuing education, and/or my ineligibility of employment (due to factors like illness, military\n    service, incarceration, or death).",
    description2: "Based upon my understanding of the above, I hereby authorize the following:",
    description3: "I further agree IntelliTec may use the above-referenced information for informational, reporting, or promotional purposes.\n    IntelliTec may also elect to use my image as part of advertising/promotional materials appearing in print, electronic, or\n    other media. I grant to IntelliTec and its licensees, successors, and assignees the right to use, without financial payment\n    or compensation, my image or likeness in any manner in external or internal publications or advertising/marketing\n    materials (including, though not necessarily limited to posters, magazines, catalogs, newsletters, websites, social media,\n    and TV/radio programming). I acknowledge IntelliTec is under no affirmative obligation to use my image or likeness and\n    that I do not have a right to inspect any proposed publication or distribution of my image or likeness prior to its use,\n    publication, or dissemination.",
    following: [
        {
            label: "1",
            description: "IntelliTec may release my grades (including a complete Academic Transcript), attendance information, and any\n            other information directly related to my attendance at IntelliTec to employers and potential employers upon their\n            request. Such information which may be released also includes, though is not limited to, information created in\n            cooperation with IntelliTec\u2019s Career Services Department, such as resumes, applications for employment, and\n            other relevant information the employer deems necessary for consideration for employment."
        },
        {
            label: "2",
            description: "My employer (or third party employment verifier(s) providing services to my employer) may release information\n            about my employment status to IntelliTec (or any representative of IntelliTec such as a third party verifier),\n            including but not limited to, information such as job title, job duties, identity of my manager/supervisor, date of\n            hire and/or dates of employment, rate of pay and/or salary, and general information about my employer (e.g.,\n            name, address, telephone/fax number, and name of a contact point at my employer\u2019s location)."
        },
        {
            label: "3",
            description: "Any other organization and/or entity may release requested information and any documents which relate to my\n            eligibility for employment and/or ability to work on a regular basis. Such information and documents include,\n            though are not limited to, records about my incarceration, death, immigration status, or military service."
        },
        {
            label: "4",
            description: "Any medical professional to release requested information and any documents related to my ability to work in my\n            field of study including, but not limited to, records of permanent or temporary disability and pregnancy."
        },
        {
            label: "5",
            description: "Schools, universities, colleges, or any other educational institution may release information sufficient to confirm\n            my attendance, including but not limited to, dates of attendance/enrollment, transcripts, enrollment agreements,\n            attendance records, and degrees/awards conferred."
        }
    ],
    footer: {
        left: "",
        right: "Vs. 1.2 04/20/2017"
    }
};
exports.STUDENT_AUTHORIZATION_INFORMATION = STUDENT_AUTHORIZATION_INFORMATION;
var STUDENT_AUTHORIZATION_INFORMATION_4_6 = {
    title: "Authorization to Release Information",
    description1: "IntelliTec Colleges (\u201CIntelliTec\u201D) must regularly collect and report on the educational and employment outcomes of our\n    students. Accordingly, I understand it may be necessary for IntelliTec to verify matters that affect career training such as\n    employment status, continuing education, and/or my ineligibility of employment (due to factors like illness, military\n    service, incarceration, or death).",
    description2: "Based upon my understanding of the above, I hereby authorize the following:",
    description3: "I further agree IntelliTec may use the above-referenced information for informational, reporting, or promotional purposes.\n    IntelliTec may also elect to use my image as part of advertising/promotional materials appearing in print, electronic, or\n    other media. I grant to IntelliTec and its licensees, successors, and assignees the right to use, without financial payment\n    or compensation, my image or likeness in any manner in external or internal publications or advertising/marketing\n    materials (including, though not necessarily limited to posters, magazines, catalogs, newsletters, websites, social media,\n    and TV/radio programming). I acknowledge IntelliTec is under no affirmative obligation to use my image or likeness and\n    that I do not have a right to inspect any proposed publication or distribution of my image or likeness prior to its use,\n    publication, or dissemination.",
    following: [
        {
            label: "1",
            description: "IntelliTec may release my grades (including a complete Academic Transcript), attendance information, and any\n            other information directly related to my attendance at IntelliTec to employers and potential employers upon their\n            request. Such information which may be released also includes, though is not limited to, information created in\n            cooperation with IntelliTec\u2019s Career Services Department, such as resumes, applications for employment, and\n            other relevant information the employer deems necessary for consideration for employment."
        },
        {
            label: "2",
            description: "My employer (or third party employment verifier(s) providing services to my employer) may release information\n            about my employment status to IntelliTec (or any representative of IntelliTec such as a third party verifier),\n            including but not limited to, information such as job title, job duties, identity of my manager/supervisor, date of\n            hire and/or dates of employment, rate of pay and/or salary, and general information about my employer (e.g.,\n            name, address, telephone/fax number, and name of a contact point at my employer\u2019s location)."
        },
        {
            label: "3",
            description: "Any other organization and/or entity may release requested information and any documents which relate to my\n            eligibility for employment and/or ability to work on a regular basis. Such information and documents include,\n            though are not limited to, records about my incarceration, death, immigration status, or military service."
        },
        {
            label: "4",
            description: "Any medical professional to release requested information and any documents related to my ability to work in my\n            field of study including, but not limited to, records of permanent or temporary disability and pregnancy."
        },
        {
            label: "5",
            description: "Schools, universities, colleges, or any other educational institution may release information sufficient to confirm\n            my attendance, including but not limited to, dates of attendance/enrollment, transcripts, enrollment agreements,\n            attendance records, and degrees/awards conferred."
        },
        {
            label: "6",
            description: "In consideration of my willingness to appear in photographs and videography that IntelliTec College may elect to\n            use in print or any other media, or to be quoted concerning comments I have made about my student\n            experience at IntelliTec College, I irrevocably grant to IntelliTec College and its licensees, successors, and\n            assignees the right to use such media or comments and any portion thereof in any manner in external or internal\n            print or digital media, such as newspaper, radio, magazines, websites, TV, social media, newsletters, internal\n            training materials, or posting on college walls without financial payment or compensation."
        }
    ],
    footer: {
        left: "",
        right: "Vs. 1.3 01/15/2026"
    }
};
exports.STUDENT_AUTHORIZATION_INFORMATION_4_6 = STUDENT_AUTHORIZATION_INFORMATION_4_6;
var STUDENT_CRIMINAL_CONVICTION_ADVISEMENT = {
    title: "Criminal Conviction/Inoculation and Screening Advisement",
    description1: "I have discussed with my Admissions Representative that any of the below items may adversely affect my\n    ability to secure an externship or enter the workforce:",
    points: [
        "Invalid Driver`s License/moving violations on driving record for jobs that require driving",
        "Felony Convictions and/or inability to discuss and explain rehabilitative steps",
        "Failure to pass required background checks/drug screenings"
    ],
    description2: "It is my responsibility to investigate fully any barriers to employment prior to entering training in my chosen\n    field. This may include, but is not limited to, the inability or ineligibility to obtain licensure, certification,\n    bonding, or insurance.",
    description3: "If I choose to enroll at IntelliTec Colleges, I will do so with the full knowledge and understanding of the possible\n    negative impact of a criminal conviction, failed drug screening or failed background check on externship and/or\n    employment in my chosen field.",
    benefit: {
        identifier: "page15",
        backendClass: "form-user-student",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "Massage Therapy only",
                description1: "I understand that the Colorado State Department of Regulatory Agencies (DORA) and the New Mexico Massage\n                Therapy Board could reject my application for massage therapy licensure if I have been convicted and/or pled\n                guilty to:",
                points: [
                    "Prostitution-Related Offenses",
                    "Unlawful Sexual Behavior Offenses",
                    "Human-Trafficking Related Offenses",
                    "Other felonies as determined by DORA"
                ],
                description2: "I understand that failure to disclose fully and accurately any requested criminal history information could\n                constitute grounds for denial of my application.",
                description3: "In addition, I understand that I will not be able to obtain licensure with the New Mexico Massage Therapy\n                board if I am not at least 18 years of age and have not completed High School or its equivalent."
            },
            {
                title: "Cosmetologist Only",
                description1: "I understand that the following may adversely affect my securing licensure and/or employment in my chosen\n                field of study:",
                points: ["Felony convictions", "Substance Abuse"],
                description2: "I understand that failure to disclose fully and accurately any requested criminal history information could\n                constitute grounds for denial of my application.",
                description3: "In addition, I understand that the State Board requires a High School Diploma or equivalent to sit for the\n                Cosmetologist state board."
            },
            {
                title: "Medical Assistant and Nursing Assistant Only:",
                description1: "I understand and agree that I may be required to obtain and provide proof of any or all the following: MMR, TB Tine,\n                COVID-19, and Hepatitis B inoculations, prior to beginning any clinical lab classes or prior to obtaining employment in\n                these fields.",
                points: [],
                description2: ""
            },
            {
                title: "Dental Assistant and Medical Billing and Coding Only:",
                description1: "I understand and agree that I may be required to provide proof of the COVID-19 vaccination prior to beginning any\n                Clinical lab class or prior to obtaining employment in these fields.",
                points: [],
                description2: ""
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 5.1 12/07/2022"
    }
};
exports.STUDENT_CRIMINAL_CONVICTION_ADVISEMENT = STUDENT_CRIMINAL_CONVICTION_ADVISEMENT;
var STUDENT_CRIMINAL_CONVICTION_ADVISEMENT_4_6 = {
    title: "Criminal Conviction/Inoculation and Screening Advisement",
    description1: "I have discussed with my Admissions Representative that any of the below items may adversely affect my\n    ability to secure an externship or enter the workforce:",
    points: [
        "Invalid Driver`s License/moving violations on driving record for jobs that require driving",
        "Felony Convictions and/or inability to discuss and explain rehabilitative steps",
        "Failure to pass required background checks/drug screenings"
    ],
    description2: "It is my responsibility to investigate fully any barriers to employment prior to entering training in my chosen\n    field. This may include, but is not limited to, the inability or ineligibility to obtain licensure, certification,\n    bonding, or insurance.",
    description3: "If I choose to enroll at IntelliTec Colleges, I will do so with the full knowledge and understanding of the possible\n    negative impact of a criminal conviction, failed drug screening or failed background check on externship and/or\n    employment in my chosen field.",
    benefit: {
        identifier: "page15",
        backendClass: "form-user-student",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "Massage Therapy only",
                description1: "I understand that the Colorado State Department of Regulatory Agencies (DORA) and the New Mexico Massage\n                Therapy Board could reject my application for massage therapy licensure if I have been convicted and/or pled\n                guilty to:",
                points: [
                    "Prostitution-Related Offenses",
                    "Unlawful Sexual Behavior Offenses",
                    "Human-Trafficking Related Offenses",
                    "Other felonies as determined by DORA"
                ],
                description2: "I understand that failure to disclose fully and accurately any requested criminal history information could\n                constitute grounds for denial of my application.",
                description3: "In addition, I understand that I will not be able to obtain licensure with the New Mexico Massage Therapy\n                board if I am not at least 18 years of age and have not completed High School or its equivalent."
            },
            {
                title: "Cosmetologist Only",
                description1: "I understand that the following may adversely affect my securing licensure and/or employment in my chosen\n                field of study:",
                points: ["Felony convictions", "Substance Abuse"],
                description2: "I understand that failure to disclose fully and accurately any requested criminal history information could\n                constitute grounds for denial of my application.",
                description3: "In addition, I understand that the State Board requires a High School Diploma or equivalent to sit for the\n                Cosmetologist state board."
            },
            {
                title: "Medical Assistant and Nursing Assistant Only:",
                description1: "I understand and agree that I may be required to obtain and provide proof of any or all the following: MMR, TB Tine,\n                COVID-19, and Hepatitis B inoculations, prior to beginning any clinical lab classes or prior to obtaining employment in\n                these fields.",
                points: [],
                description2: ""
            },
            {
                title: "Dental Assistant and Medical Billing and Coding Only:",
                description1: "I understand and agree that I may be required to provide proof of the COVID-19 vaccination prior to beginning any\n                Clinical lab class or prior to obtaining employment in these fields.",
                points: [],
                description2: ""
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 5.2 12/07/2022"
    }
};
exports.STUDENT_CRIMINAL_CONVICTION_ADVISEMENT_4_6 = STUDENT_CRIMINAL_CONVICTION_ADVISEMENT_4_6;
var STUDENT_SALARY_AND_EMPLOYMENT = {
    title: "Salary and Employment Statement",
    subtitle: "Acknowledgment",
    points: [
        "I understand that entry-level salaries and employment in the career field of\n        my choice may vary depending on geographic location, employer(s),\n        economic conditions, and my willingness to relocate.",
        "I have not been guaranteed a job or salary level.",
        "I certify that I have been informed about the nature of the career field that I\n        have chosen to pursue including barriers to entry into the workforce.",
        "I have been provided resources to independently research my future income\n        potential.",
        "Many programs require extern hours to complete the coursework and obtain\n        employment. I understand that my extern hours may not be the same as my\n        class hours and may include weekends and evening hours. In addition, I\n        understand placement at an extern site does not guarantee employment\n        after graduation."
    ],
    footer: {
        left: "",
        right: "Vs. 2.0 04/20/2017"
    }
};
exports.STUDENT_SALARY_AND_EMPLOYMENT = STUDENT_SALARY_AND_EMPLOYMENT;
var STUDENT_SALARY_AND_EMPLOYMENT_4_6 = {
    title: "Salary and Employment Statement",
    subtitle: "Acknowledgment",
    points: [
        "I understand that entry-level salaries and employment in the career field of\n        my choice may vary depending on geographic location, employer(s),\n        economic conditions, and my willingness to relocate.",
        "I understand that I have not been guaranteed employment, a specific salary or\n        wage level, or a particular job type or work arrangement (such as online or in-\n        office).",
        "I certify that I have been informed about the nature of the career field that I\n        have chosen to pursue including barriers to entry into the workforce.",
        "I have been provided resources to independently research my future income\n        potential.",
        "Many programs require extern hours to complete the coursework and obtain\n        employment. I understand that my extern hours may not be the same as my\n        class hours and may include weekends and evening hours. In addition, I\n        understand placement at an extern site does not guarantee employment\n        after graduation."
    ],
    footer: {
        left: "",
        right: "Vs. 2.0 04/20/2017"
    }
};
exports.STUDENT_SALARY_AND_EMPLOYMENT_4_6 = STUDENT_SALARY_AND_EMPLOYMENT_4_6;
var STUDENT_REFERRALS = {
    title: "Student Referrals",
    backendClass: "form-user-student",
    referals: [
        {
            name: "Referral Name",
            phone: "Phone Number",
            email: "Email"
        },
        {
            name: "Referral Name",
            phone: "Phone Number",
            email: "Email"
        },
        {
            name: "Referral Name",
            phone: "Phone Number",
            email: "Email"
        },
        {
            name: "Referral Name",
            phone: "Phone Number",
            email: "Email"
        },
        {
            name: "Referral Name",
            phone: "Phone Number",
            email: "Email"
        }
    ],
    footer: {
        left: "",
        right: "Vs. 1.0 01/30/2018"
    }
};
exports.STUDENT_REFERRALS = STUDENT_REFERRALS;
var AUTOPOPULATE_DATA = {
    datas: [
        "student-data-full_name",
        "student-data-student_name",
        "student-data-phone",
        "student-data-date_of_birth",
        "student-data-locations",
        "student-data-major",
        "student-data-address",
        "student-data-address_state",
        "student-data-address_city",
        "student-data-address_zip",
        "student-data-college_id_expiry",
        "student-data-start_date",
        "student-data-graduation_date",
        "student-data-career_services_advisor"
    ],
    keyField: "student-data-"
};
exports.AUTOPOPULATE_DATA = AUTOPOPULATE_DATA;
var NURSING_STUDENT_INFORMATION = {
    title: "Enrollment Packet Information",
    description: "Fill out the fields below exactly as you would like them to appear on the forms. Please note, if there are other fields in each form that you want typed, forms can be edited directly prior to printing.",
    footer: {
        left: "",
        right: "Packet Vs. 4.5 5/24/23"
    }
};
exports.NURSING_STUDENT_INFORMATION = NURSING_STUDENT_INFORMATION;
var NURSING_STUDENT_PAYMENT_PLAN = {
    page21_one_payment_1: 2078,
    page21_two_payment_1: 1039,
    page21_two_payment_2: 1039,
    page21_four_payment_1: 519.50,
    page21_four_payment_2: 519.50,
    page21_four_payment_3: 519.50,
    page21_four_payment_4: 519.50
};
exports.NURSING_STUDENT_PAYMENT_PLAN = NURSING_STUDENT_PAYMENT_PLAN;
var NURSING_STUDENT_CHECKLIST = {
    title: "",
    description: "",
    sections: {
        section1: {
            title: "Section 1",
            description: "",
            items: [
                {
                    label: "Student File Checklist"
                }
            ]
        },
        section2: {
            title: "Section 2",
            description: "",
            items: [
                {
                    label: "Completed Enrollment Agreement"
                },
                {
                    label: "Copy of Acceptance Letter"
                },
                {
                    label: "Copy of High School Transcript or GED"
                },
                {
                    label: "Career Training Kickoff (CTK)"
                },
                {
                    label: "Student Arbitration Agreement"
                },
                {
                    label: "Transcript Request (as applicable)"
                },
                {
                    label: "Disclosure Packet Acknowledgement ( ASR, Drug & Alcohol, FERPA, & Consumer Right-to-Know, Test-Out, Student Dress Code, Class Schedule )"
                }
            ]
        },
        section3: {
            title: "Section 3",
            description: "",
            items: [
                {
                    label: "FERPA Release & Emergency Contact"
                },
                {
                    label: "FERPA Disclosure Record"
                },
                {
                    label: "Student and Graduate Media Release"
                },
                {
                    label: "Authorization to Release Information"
                },
                {
                    label: "Criminal Conviction and Screening"
                },
                {
                    label: "Salary and Employment Statement"
                },
                {
                    label: "Nursing Assistant Health Statement/Vaccine/Background Check Form"
                }
            ]
        },
        section4: {
            title: "Section 4",
            description: "",
            items: [
                {
                    label: "Copy of Official Government ID"
                },
                {
                    label: "Institutional Application Form for NA"
                },
                {
                    label: "Student Profile Form"
                },
                {
                    label: "Distance Learning Assessment"
                },
                {
                    label: "Payment plan"
                }
            ]
        },
        section5: {
            title: "Section 5",
            description: "Student Forms (as applicable can include but not limited):",
            items: [
                {
                    label: "Attendance Sheets/Tests"
                },
                {
                    label: "Syllabus/LRS"
                },
                {
                    label: "Title IX Acknowledgement"
                }
            ]
        },
        section6: {
            title: "Section 6",
            description: "",
            items: [
                {
                    label: "Transcripts/Grad Forms"
                },
                {
                    label: "DORA License"
                },
                {
                    label: "Externship Packet"
                },
                {
                    label: "Extern Confidentiality"
                },
                {
                    label: "Designated Medical Provider"
                },
                {
                    label: "PHI Release & TB Screening"
                }
            ]
        }
    },
    exitDates: {
        title: "Exit Dates (as applicable)",
        dates: {
            intro: "Introductory Period Exit Date",
            drops: "Drop Dates",
            graduation: "Graduation Date",
            loa: "LOA Dates",
            to: "TO"
        }
    },
    enrollmentAdmission: {
        initials: "Enrollment Packet Complete Admissions Rep Initials",
        file: "File Complete Registrar Initials",
        completed: "Date Completed"
    },
    footer: {
        left: "",
        right: "Vs. 2.7 7/28/2022"
    }
};
exports.NURSING_STUDENT_CHECKLIST = NURSING_STUDENT_CHECKLIST;
var NURSING_STUDENT_INTRODUCTORY_PERIOD = {
    title: "Career Training Kickoff (CTK) Notification Nursing Assistant Program",
    description: "Career Training Kickoff (CTK), a one-hour session prior to the start of Nursing Assistant classes, provides students tools and resources that are necessary to successfully complete training and prepare for their\n    career. The course is scheduled on the Wednesday of the week prior to your start date.",
    condition: {
        title: "CTK Requirements",
        fill: "Please initial each statement below:",
        backendClass: "form-user-student form-required",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "training",
                checked: false,
                descriptions: [
                    "I understand that Career Training Kickoff is mandatory for my program, and I am required to attend the one-hour session. All new and returning students are required to complete the session\n                prior to the start of their Nursing Assistant classes."
                ]
            },
            {
                title: "attendance",
                checked: false,
                descriptions: [
                    "I understand that Career Training Kickoff is offered at no additional cost and attendance is recorded. The course does not qualify as actual credits towards my certificate program."
                ]
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 1.0 " + helper_1.getFormatDateNow()
    }
};
exports.NURSING_STUDENT_INTRODUCTORY_PERIOD = NURSING_STUDENT_INTRODUCTORY_PERIOD;
var NURSING_STUDENT_ARBITRATION_AGREEMENT = {
    title: "STUDENT ARBITRATION AGREEMENT",
    description: {
        first: 'The Parties to this Student Arbitration Agreement("Agreement") are',
        seccond: '("Student") and IntelliTec Colleges ("College").'
    },
    aggrement: {
        title: "",
        conditions: [
            {
                subtitle: "Claims Subject to Arbitration.",
                description: "Any and all disputes or claims between the Parties or any of College's officers, directors, employees, or agents, whether arising in tort, contract, statute, or otherwise and relating in any manner to Student's relationship with College, shall be resolved through binding arbitration pursuant to this agreement, including any dispute regarding the enforceability, scope, or validity of this Agreement. As exceptions to this provision, the Parties may file a lawsuit within the jurisdiction of a Colorado small claims court and Student may file a complaint or charge with any administrative agency which has independent jurisdiction to investigate such a claim."
            },
            {
                subtitle: "Governing Law and Rules.",
                description: "Arbitration under this Agreement shall be governed by the Federal Arbitration Act and conducted under the American Arbitration Association's Consumer Arbitration Rules (\"AAA Rules\")."
            },
            {
                subtitle: "Notice of Arbitration",
                description: "Arbitration under this Agreement shall be initiated by submitting a written demand to the other Party. Student shall submit any demand to Chief Executive Officer, 2504 East Pikes Peak Ave, Ste. 305 Colorado Springs, CO 80909."
            },
            {
                subtitle: "Arbitration Hearing.",
                description: "Arbitration pursuant to this Agreement shall be conducted by one arbitrator who may be agreed upon by the Parties or, in the event the Parties cannot agree, as selected through or appointed by AAA. The hearing shall take place in the country in which the College campus attended by the Student is located. The decision of the Arbitrator shall be final and binding. The Arbitrator shall have authority to award any relief that would be available in a court on the claim or claims asserted."
            },
            {
                subtitle: "No Class or Collective Action.",
                description: "We agree that neither we nor anyone else who later becomes a party to this agreement will use this agreement to stop you from being part of a class action lawsuit in court. You may file a class action lawsuit in court or you may be a member of a class action lawsuit even if you do not file it. This provision applies only to class action claims concerning our acts or omissions regarding the making of the Federal Direct Loan or the provision by us of educational services for which the Federal Direct Loan was obtained. We agree that only the court is to decide whether a claim asserted in the lawsuit is a claim regarding the making of the Federal Direct Loan or the provision of educational services for which the loan was obtained."
            },
            {
                subtitle: "Arbitration Fees and Costs.",
                description: "Each party will bear the expense of its own attorneys, experts, and witnesses, regardless of which party prevails, unless applicable law gives a right to recover any of those expenses from the other party. Responsibility to pay administrative and filing fees, arbitrator compensation or other costs related to the arbitration proceedings conducted by the AAA shall be according to the AAA Rules in effect at the time of commencement of the Arbitration."
            },
            {
                subtitle: "Confidentiality.",
                description: "Except as may be required by law, neither a Party nor an Arbitrator may disclose the existence, content of any arbitration conducted pursuant to this Agreement without the written consent of both parties."
            },
            {
                subtitle: "Severability.",
                description: "If any provision of this Agreement (other than the provisions of paragraph 5 above), is held illegal or unenforceable in a judicial proceeding or arbitration, such provision shall be severed and inoperative, but the\n                remainder of the provisions shall remain operative and binding upon the Parties."
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 1.2 " + helper_1.getFormatDateNow()
    }
};
exports.NURSING_STUDENT_ARBITRATION_AGREEMENT = NURSING_STUDENT_ARBITRATION_AGREEMENT;
var NURSING_STUDENT_LICENCE_AGREEMENT = {
    title: "",
    description: {
        first: "THIS AGREEMENT LIMITS CERTAIN RIGHTS, INCLUDING THE RIGHT TO MAINTAIN A COURT ACTION,\n        THE RIGHT TO A JURY TRIAL, THE RIGHT TO PARTICIPATE IN DISCOVERY (EXCEPT AS PROVIDED FOR\n        IN THE AAA RULES), AND THE RIGHT TO PARTICIPATE IN ANY FORM OF CLASS OR JOINT CLAIM. OTHER\n        RIGHTS THAT STUDENT OR COLLEGE MAY HAVE IN COURT MAY ALSO NOT BE AVAILABLE IN\n        ARBITRATION.",
        seccond: "BY SIGNING BELOW (AND INITIALING ABOVE), STUDENT CONFIRMS HE/SHE HAS READ THE TERMS OF\n        THIS AGREEMENT, HAS HAD TIME TO CONSIDER ITS TERMS (INCLUDING AN OPPORTUNITY TO\n        CONSULT WITH AN ATTORNEY AT HIS/HER CHOOSING AND EXPENSE), AND AGREES TO ALL OF THE\n        TERMS CONTAINED IN IT. IN ADDITION, STUDENT SHALL HAVE 2 WEEKS FROM THE DATE HE/SHE\n        SIGNS THE ENROLLMENT AGREEMENT AND THIS AGREEMENT TO REJECT THEM IN WRITING."
    },
    footer: {
        left: "",
        right: "Vs. 1.2 " + helper_1.getFormatDateNow()
    }
};
exports.NURSING_STUDENT_LICENCE_AGREEMENT = NURSING_STUDENT_LICENCE_AGREEMENT;
var NURSING_STUDENT_TRANSCRIPT_REQUEST = {
    title: "Transcript Request",
    title2: "Authorization for Release of School/College/Testing Center Records",
    description: "Please return Top Portion with Transcript -- Detach and retain Bottom Portion for your Records",
    fee: {
        highSchool: {
            title: "High School Transcript",
            placeholder: "Enter your high school fee",
            description: "Fee",
            identifier: "page7_fee_1"
        },
        college: {
            title: "College Transcript",
            placeholder: "Enter your college fee",
            description: "Fee",
            identifier: "page7_fee_2"
        },
        ged: {
            title: "GED Testing Results",
            placeholder: "Enter your ged fee",
            description: "Fee",
            identifier: "page7_fee_3"
        },
        warning: "Transcript fee, if required, will be paid by receiving Institution upon receipt of transcript and/or notification of charges."
    },
    transcripts: {
        colorado: {
            title: "IntelliTec College Colorado Springs",
            address: "2315 E. Pikes Peak Ave",
            city: "Colorado Springs, CO 80909",
            attn: "Registrar",
            fax: "719.213.2306",
            identifier: "page7_transcript_address_1"
        },
        grandJunction: {
            title: "IntelliTec College Grand Junction",
            address: "772 Horizon Drive",
            city: "Grand Junction, CO 81506",
            attn: "Registrar",
            fax: "970.797.1677",
            identifier: "page7_transcript_address_2"
        },
        pueblo: {
            title: "IntelliTec College Pueblo",
            address: "3673 Parker Blvd Suite 250",
            city: "Pueblo, CO 81008",
            attn: "Registrar",
            fax: "719.543.1056",
            identifier: "page7_transcript_address_3"
        },
        abq: {
            title: "IntelliTec College ABQ",
            address: "4575 San Mateo Blvd. NE Suite K",
            city: "Albuquerque, NM 87109",
            attn: "Registrar",
            fax: "505.214.5045",
            identifier: "page7_transcript_address_4"
        }
    },
    footer: {
        left: "",
        right: "Vs. 4.1 05/24/2023"
    },
    remove: "************************************************************************************************"
};
exports.NURSING_STUDENT_TRANSCRIPT_REQUEST = NURSING_STUDENT_TRANSCRIPT_REQUEST;
var NURSING_STUDENT_DISCLOSURE_PACKET = {
    title: "Disclosure Packet",
    description: "(Please initial each item, all below policies are in the Disclosure Packet Handout VS 2.0)",
    conditionList1: {
        title: "",
        backendClass: "form-user-student form-required",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "security",
                isDisplayBlock: true,
                descriptions: [
                    "Annual Security Report",
                    "I certify that I have been advised by IntelliTec Colleges of the availability of the Campus Annual Security Report, crime\n                statistics, and the url where I can access the report. I understand that I may request a paper copy from the Campus\n                Registrar at no charge."
                ]
            },
            {
                title: "prevention",
                isDisplayBlock: true,
                separator: true,
                descriptions: [
                    "Drug and Alcohol Abuse Prevention Policy",
                    "I certify that I have been advised of IntelliTec Colleges\u2019 Drug and Alcohol Abuse Prevention policy in accordance with\n                the Education Department General Administrative Regulations (EDGAR) Title 34 Part 86 Drug Prevention and Abuse\n                and Section 120 of Title I of the Higher Education Act of 1965. This policy prohibits, the manufacture; sale, purchase,\n                distribution or other transfer; possession; or being impaired or under the influence, of any controlled substance\n                including alcohol; illegal drugs; legal drugs used or to be used illegally; or medicinal or recreational marijuana."
                ]
            }
        ]
    },
    conditionList2: {
        title: "",
        backendClass: "form-user-student form-required",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "notifications",
                isDisplayBlock: true,
                descriptions: [
                    "Notification of Rights under FERPA (Family Educational Rights & Privacy Act)",
                    "I have received and read a copy of my rights under FERPA. I understand my rights regarding FERPA release of\n                personally identifiable information and the release of Directory information."
                ]
            },
            {
                title: "consumer",
                isDisplayBlock: true,
                descriptions: [
                    "Consumer Right-To-Know",
                    "I have received and read a copy of the Consumer Information form and understand that I can find applicable right-to-\n                know information at <a href=\"https://intellitec.edu/\" rel=\"noreferrer\">www.intellitec.edu</a> under the heading <strong>Consumer Information</strong>."
                ]
            },
            {
                title: "request",
                isDisplayBlock: true,
                descriptions: [
                    "Test-Out Request",
                    "I have received and read a copy of the student Test-Out form and understand that to test out of a course I must request\n                this in writing by submitting the Test-Out form to the Registrar\u2019s office within the first 6 weeks of my program. More\n                information is available on Test-Outs in the Student Catalog."
                ]
            },
            {
                title: "student",
                isDisplayBlock: true,
                descriptions: [
                    "Student Dress Code",
                    "I have been provided a copy of the Student Dress Code Policy, have read the policies, and\n                understand that I must abide by the requirements set forth in it."
                ]
            },
            {
                title: "schedule",
                isDisplayBlock: true,
                descriptions: [
                    "Class Schedule",
                    "I have been provided a copy of my program class times. <div><strong>I acknowledge the above statements, have been provided the corresponding disclosure paperwork, and understand\n                that I can request additional information at any time.</strong></div>"
                ]
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 2.1 " + helper_1.getFormatDateNow()
    }
};
exports.NURSING_STUDENT_DISCLOSURE_PACKET = NURSING_STUDENT_DISCLOSURE_PACKET;
var NURSING_STUDENT_FERPA_RELEASE_FORM = {
    title: "FERPA RELEASE FORM/EMERGENCY CONTACT",
    subtitle1: "FERPA Release Consent",
    subtitle2: "Emergency Contact",
    description: "In compliance with the Family Educational Rights and Privacy Act (FERPA) of 1974 as amended, IntelliTec Colleges will not release student information beyond the college\u2019s directory information to any thirdparty without written permission by the student. IntelliTec Colleges\n    reserves the right to review and respond to requests for release of education records on a case-by-case basis.",
    description2: "I understand that (1) I have the right not to consent to the release of my education records; (2) that I have the right to inspect any\n    written records released pursuant to this consent (3) and that this consent will remain in effect until revoked by me, in writing and\n    delivered to the Registrar at my Intellitec College campus. The revocation of consent shall not affect disclosures made by IntelliTec prior\n    to the receipt of any such written revocation. The most recently dated form in my file will supersede any previous forms completed.",
    footer: {
        left: "",
        right: "Vs. 1.0 " + helper_1.getFormatDateNow()
    }
};
exports.NURSING_STUDENT_FERPA_RELEASE_FORM = NURSING_STUDENT_FERPA_RELEASE_FORM;
var NURSING_STUDENT_FERPA_RECORD_DISCLOSURE = {
    title: "Record of Disclosure (FERPA)",
    subtitle: "IntelliTec Colleges has disclosed this student’s record under Section 99 of the U.S. Department of Education regulations.",
    description: "**Financial, Financial Aid, Academic, Disciplinary, All records, or other (specify)",
    records: {
        header: [
            {
                label: "#",
                hasTooltip: false
            },
            {
                label: "Name",
                hasTooltip: false
            },
            {
                label: "Affiliation",
                hasTooltip: false
            },
            {
                label: "Purpose",
                hasTooltip: false
            },
            {
                label: "Type of Record**",
                hasTooltip: true,
                description: "**Financial, Financial Aid, Academic, Disciplinary, All records, or other (specify)"
            },
            {
                label: "Date",
                hasTooltip: false
            }
        ],
        rows: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13]
    },
    footer: {
        left: "",
        right: "Vs. 1.1 " + helper_1.getFormatDateNow()
    }
};
exports.NURSING_STUDENT_FERPA_RECORD_DISCLOSURE = NURSING_STUDENT_FERPA_RECORD_DISCLOSURE;
var NURSING_STUDENT_GRADUATE_MEDIA_RELEASE_FORM = {
    title: "Student and Graduate Media Release Form",
    description1: "In consideration of my willingness to appear in photographs and videography (\u201CMedia\u201D) that IntelliTec College\n    may elect to use in print or any other media, or to be quoted concerning comments I have made about my\n    student experience at IntelliTec College, I irrevocably grant to IntelliTec College and its licensees, successors, and\n    assignees the right to use such media or comments and any portion thereof in any manner in external or internal\n    print or digital media, such as newspaper, radio, magazines, websites, TV, social media, newsletters, internal\n    training materials, or posting on college walls without financial payment or compensation.",
    description2: "I acknowledge that IntelliTec College is under no obligation to use any media in which I appear, and I hereby\n    waive any right to inspect the media or quotations or any uses thereof. I further waive any claims that I may\n    have against IntelliTec College and its licensees, successors, and assignees, based upon the above actions or\n    uses, including, without limitation, any claims for invasion of privacy, violation of the right of publicity, libel, and\n    copyright infringement.",
    description3: "In addition, IntelliTec is authorized to use this information internally for informational and promotional\n    purposes.",
    footer: {
        left: "",
        right: "Vs. 2.1 " + helper_1.getFormatDateNow()
    }
};
exports.NURSING_STUDENT_GRADUATE_MEDIA_RELEASE_FORM = NURSING_STUDENT_GRADUATE_MEDIA_RELEASE_FORM;
var NURSING_STUDENT_AUTHORIZATION_INFORMATION = {
    title: "Authorization to Release Information",
    description1: "IntelliTec Colleges (\u201CIntelliTec\u201D) must regularly collect and report on the educational and employment outcomes of our\n    students. Accordingly, I understand it may be necessary for IntelliTec to verify matters that affect career training such as\n    employment status, continuing education, and/or my ineligibility of employment (due to factors like illness, military\n    service, incarceration, or death).",
    description2: "Based upon my understanding of the above, I hereby authorize the following:",
    description3: "I further agree IntelliTec may use the above-referenced information for informational, reporting, or promotional purposes.\n    IntelliTec may also elect to use my image as part of advertising/promotional materials appearing in print, electronic, or\n    other media. I grant to IntelliTec and its licensees, successors, and assignees the right to use, without financial payment\n    or compensation, my image or likeness in any manner in external or internal publications or advertising/marketing\n    materials (including, though not necessarily limited to posters, magazines, catalogs, newsletters, websites, social media,\n    and TV/radio programming). I acknowledge IntelliTec is under no affirmative obligation to use my image or likeness and\n    that I do not have a right to inspect any proposed publication or distribution of my image or likeness prior to its use,\n    publication, or dissemination.",
    following: [
        {
            label: "1",
            description: "IntelliTec may release my grades (including a complete Academic Transcript), attendance information, and any\n            other information directly related to my attendance at IntelliTec to employers and potential employers upon their\n            request. Such information which may be released also includes, though is not limited to, information created in\n            cooperation with IntelliTec\u2019s Career Services Department, such as resumes, applications for employment, and\n            other relevant information the employer deems necessary for consideration for employment."
        },
        {
            label: "2",
            description: "My employer (or third party employment verifier(s) providing services to my employer) may release information\n            about my employment status to IntelliTec (or any representative of IntelliTec such as a third party verifier),\n            including but not limited to, information such as job title, job duties, identity of my manager/supervisor, date of\n            hire and/or dates of employment, rate of pay and/or salary, and general information about my employer (e.g.,\n            name, address, telephone/fax number, and name of a contact point at my employer\u2019s location)."
        },
        {
            label: "3",
            description: "Any other organization and/or entity may release requested information and any documents which relate to my\n            eligibility for employment and/or ability to work on a regular basis. Such information and documents include,\n            though are not limited to, records about my incarceration, death, immigration status, or military service."
        },
        {
            label: "4",
            description: "Any medical professional to release requested information and any documents related to my ability to work in my\n            field of study including, but not limited to, records of permanent or temporary disability and pregnancy."
        },
        {
            label: "5",
            description: "Schools, universities, colleges, or any other educational institution may release information sufficient to confirm\n            my attendance, including but not limited to, dates of attendance/enrollment, transcripts, enrollment agreements,\n            attendance records, and degrees/awards conferred."
        }
    ],
    footer: {
        left: "",
        right: "Vs. 1.2 " + helper_1.getFormatDateNow()
    }
};
exports.NURSING_STUDENT_AUTHORIZATION_INFORMATION = NURSING_STUDENT_AUTHORIZATION_INFORMATION;
var NURSING_STUDENT_CRIMINAL_CONVICTION_ADVISEMENT = {
    title: "Criminal Conviction/Inoculation and Screening Advisement",
    description1: "I have discussed with my Admissions Representative that any of the below items may adversely affect my\n    ability to secure an externship or enter the workforce:",
    points: [
        "Invalid Driver’s License/moving violations on driving record for jobs that require driving",
        "Felony Convictions and/or inability to discuss and explain rehabilitative steps",
        "Failure to pass required background checks/drug screenings"
    ],
    description2: "It is my responsibility to investigate fully any barriers to employment prior to entering training in my chosen\n    field. This may include, but is not limited to, the inability or ineligibility to obtain licensure, certification,\n    bonding, or insurance.",
    description3: "If I choose to enroll at IntelliTec Colleges, I will do so with the full knowledge and understanding of the possible\n    negative impact of a criminal conviction, failed drug screening or failed background check on externship and/or\n    employment in my chosen field.",
    benefit: {
        identifier: "page15",
        backendClass: "form-user-student",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "Massage Therapy only",
                description1: "I understand that the Colorado State Department of Regulatory Agencies (DORA) could reject my application for\n                massage therapy licensure if I have been convicted and/or pled guilty to:",
                points: [
                    "Prostitution-Related Offenses",
                    "Unlawful Sexual Behavior Offenses",
                    "Human-Trafficking Related Offenses",
                    "Other felonies as determined by DORA"
                ],
                description2: "In addition, I understand that failure to disclose fully and accurately any requested criminal history information\n                could constitute grounds for denial of my application."
            },
            {
                title: "Cosmetologist Only",
                description1: "I understand that the following may adversely affect my securing licensure and/or employment in my chosen\n                field of study:",
                points: ["Felony convictions", "Substance Abuse"],
                description2: "In addition, I understand that failure to disclose fully and accurately any requested criminal history information\n                could constitute grounds for denial of my application."
            },
            {
                title: "Pharmacy Technician Only",
                description1: "A background check is required prior to acceptance of enrollment and will be required prior to the start of\n                externship placement. I understand that the following may adversely affect my securing an externship and/or\n                employment in my chosen field of study:",
                points: [
                    "Substance Abuse",
                    "Medical and/or Government Assistance Fraud convictions/pleas",
                    "Other felonies"
                ],
                description2: ""
            },
            {
                title: "Medical Assistant and Nursing Assistant Only:",
                description1: "I understand and agree that I may be required to obtain and provide proof of any or all the following: MMR, TB Tine,\n                COVID-19, and Hepatitis B inoculations, prior to beginning any clinical lab classes or prior to obtaining employment in these\n                fields.",
                points: [],
                description2: ""
            },
            {
                title: "Dental Assistant and Medical Billing and Coding Only:",
                description1: "I understand and agree that I may be required to provide proof of the COVID-19 vaccination prior to beginning any clinical\n                lab class or prior to obtaining employment in these fields.",
                points: [],
                description2: ""
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 4.0 " + helper_1.getFormatDateNow()
    }
};
exports.NURSING_STUDENT_CRIMINAL_CONVICTION_ADVISEMENT = NURSING_STUDENT_CRIMINAL_CONVICTION_ADVISEMENT;
var NURSING_STUDENT_SALARY_AND_EMPLOYMENT = {
    title: "Salary and Employment Statement",
    subtitle: "Acknowledgment",
    points: [
        "I understand that entry-level salaries and employment in the career field of\n        my choice may vary depending on geographic location, employer(s),\n        economic conditions, and my willingness to relocate.",
        "I have not been guaranteed a job or salary level.",
        "I certify that I have been informed about the nature of the career field that I\n        have chosen to pursue including barriers to entry into the workforce.",
        "I have been provided resources to independently research my future income\n        potential.",
        "Many programs require extern hours to complete the coursework and obtain\n        employment. I understand that my extern hours may not be the same as my\n        class hours and may include weekends and evening hours. In addition, I\n        understand placement at an extern site does not guarantee employment\n        after graduation."
    ],
    footer: {
        left: "",
        right: "Vs. 2.0 " + helper_1.getFormatDateNow()
    }
};
exports.NURSING_STUDENT_SALARY_AND_EMPLOYMENT = NURSING_STUDENT_SALARY_AND_EMPLOYMENT;
var NURSING_STUDENT_HEALT_STATEMENT = {
    title1: "HEALTH STATEMENT",
    title2: "PROOF OF VACCINATIONS , & CRIMINAL BACKGROUND CHECK",
    description1: "IntelliTec College\u2019s Nursing Assistant Program is a 4-week Program; therefore, we do not require a Health Check. We do need to know that you are in good health and that you are able to lift at\n    least 20 lbs.",
    description2: "IntelliTec College & Clinical Sites require a TB Test and a flu shot during flu season when shots are available. Documentation of current vaccinations must be turned into the Program Supervisor\n    no later than the Start date.",
    condition: {
        title: "",
        backendClass: "form-user-student form-required",
        backendType: "form-initials-student",
        conditions: [
            {
                title: "1",
                checked: false,
                descriptions: [
                    "I have been advised and attest that I am able to lift at least 20 lbs."
                ]
            },
            {
                title: "2",
                checked: false,
                descriptions: [
                    "I have been advised that I must provide proof of a current TB test."
                ]
            },
            {
                title: "3",
                checked: false,
                descriptions: [
                    "I have been advised that I must provide proof of a current flu shot. (if applicable)"
                ]
            },
            {
                title: "4",
                checked: false,
                descriptions: [
                    "I have been advised that IntelliTec College requires a background check for their Nursing Assistant Program and I give IntelliTec College permission to do a CBI Criminal Background\n                check."
                ]
            }
        ]
    },
    footer: {
        left: "",
        right: "Vs. 2.0 " + helper_1.getFormatDateNow()
    }
};
exports.NURSING_STUDENT_HEALT_STATEMENT = NURSING_STUDENT_HEALT_STATEMENT;
var NURSING_STUDENT_REFERRALS = {
    title: "Student Referrals",
    backendClass: "form-user-student",
    referals: [
        {
            name: "Referral Name",
            phone: "Phone Number",
            email: "Email"
        },
        {
            name: "Referral Name",
            phone: "Phone Number",
            email: "Email"
        },
        {
            name: "Referral Name",
            phone: "Phone Number",
            email: "Email"
        },
        {
            name: "Referral Name",
            phone: "Phone Number",
            email: "Email"
        },
        {
            name: "Referral Name",
            phone: "Phone Number",
            email: "Email"
        }
    ],
    footer: {
        left: "",
        right: "Vs. 1.0 " + helper_1.getFormatDateNow()
    }
};
exports.NURSING_STUDENT_REFERRALS = NURSING_STUDENT_REFERRALS;
var ENROLLMENT_AGREEMENT = {
    title: "Bellus Academy - Enrollment Agreement ADDENDUM",
    subtitle1: "ENROLLMENT AGREEMENT",
    subtitle2: "All instruction will be provided at the campus location shown on this document, unless otherwise stated on a Change of Location Disclosure.",
    locations: [
        {
            address: "13266 Poway Road,",
            city_state: "Poway, CA 92064",
            number: "P (858) 748-1490; F (858) 748-7169"
        },
        {
            address: "1073 E. main Streeet,",
            city_state: "El Cajon, CA 92021",
            number: "P (619) 442-3407; F (619) 442-6718"
        },
        {
            address: "970 Broadway,",
            city_state: "Chula Vista, CA 91911",
            number: "P (619) 474-6607; F (619) 474-3849"
        },
        {
            address: "1130 Westloop Pl.,",
            city_state: "Mahattan, KS 66502",
            number: "P (785) 539-1837; F (785) 539-2535"
        }
    ],
    website: '<a href="https://www.bellusacademy.edu/" rel="noreferrer">www.bellusacademy.edu</a>',
    days: ["M", "T", "W", "TH", "F", "S"],
    itemization: [
        { label: "* Application Fee (Non-Refundable)", required: true, unique: "application_fee" },
        { label: "* Program Fees", required: true, unique: "program_fees" },
        { label: "* Tuition", required: true, unique: "tuition_cost" },
        { label: "Discounts", required: false, unique: "discounts" },
        {
            label: "Credit for Transferred Hours (See attached credit transfer forms)",
            required: false,
            unique: "transfered_hours"
        },
        {
            label: "* Kit (includes books/supplies equipment) (Non-refundable if received and signed for)",
            required: true,
            unique: "kit"
        },
        { label: "Less Opt-Out Items TOTAL", required: true, unique: "opt_out_total" },
        {
            label: "Student Tuition Recovery Fund (STRF) (Non-Refundable)",
            required: true,
            unique: "strf"
        }
    ],
    itemizationTotals: [
        {
            label: "* TOTAL CHARGES FOR THE CURRENT PERIOD OF ATTENDANCE",
            required: true,
            unique: "total_charges"
        },
        {
            label: "* TOTAL CHARGES FOR THE ENTIRE EDUCATIONAL PROGRAM",
            required: true,
            unique: "total_program",
            hasDouble: true
        },
        {
            label: "* TOTAL CHARGES THE STUDENT IS OBLIGATED TO PAY UPON ENROLLMENT",
            required: true,
            unique: "total_enrollment"
        }
    ],
    annuals: [
        {
            label: "ANNUAL PERCENTAGE RATE",
            description: "The cost of your credit as a yearly rate.",
            required: true,
            unique: "percentageRate",
            hasDouble: true
        },
        {
            label: "FINANCE CHARGE",
            description: "The dollar amount the credit will cost you.",
            required: true,
            unique: "financeCharge"
        },
        {
            label: "AMOUNT FINANCED",
            description: "The Amount of credit provided to you or on your behalf.",
            required: true,
            unique: "creditsSteps"
        },
        {
            label: "TOTAL OF PAYMENTS",
            description: "The amount you will have paid after you have made all payment as scheduled.",
            required: true,
            unique: "totalPayments"
        },
        {
            label: "TOTAL SALES PRICE",
            description: "The Total Cost of your purchase on credit",
            required: true,
            unique: "downPayments"
        }
    ],
    signatures: [
        {
            title: "Signature of Applicant",
            id: "student_signature",
            className: "form-user-student",
            type: "form-signature-student"
        },
        {
            title: "Bellus Academy Admissions Representative",
            id: "school_signature",
            className: "form-user-school_official_2",
            type: "form-user-school_official_2"
        },
        {
            title: "Signature of Spouse/Parent/Guardian",
            id: "other_signature",
            className: "form-user-student",
            type: "form-signature-student"
        }
    ],
    footer: {
        title: "BE SURE TO READ ALL PAGES OF THIS ADDENDUM. IT IS PART OF YOUR CONTRACT WITH BELLUS ACADEMY.",
        subtitle: "Revision Date: April 1, 2022",
        startPage: "1",
        endPage: "5"
    }
};
exports.ENROLLMENT_AGREEMENT = ENROLLMENT_AGREEMENT;
var SIZE_TYPE_CONSTANTS = {
    noneType: "none",
    sizeType: "size",
    shearType: "shear"
};
exports.SIZE_TYPE_CONSTANTS = SIZE_TYPE_CONSTANTS;
var OPT_OUTS = {
    title: "ATTACHMENT A ENROLLMENT AGREEMENT",
    subtitle1: "The following is a list of books and supplies, with titles and prices, used in the above-named program. Bellus Academy is continuously\n    reviewing its courses and updating its curriculum to provide its students with the most current materials available. Books and/or supplies\n    may be added or deleted from time to time. You will be charged the price of the item at the time of receipt. Bellus Academy reserves the\n    right to make these changes in an effort to continually give you the best education possible in your chosen field.",
    text1: "Some items are bundled and distributed by the school. The student may elect to purchase books and/or supplies on their own. As noted above,\n    some items must be purchased directly from the school. For health and safety reasons, once the kits have been opened, they are not returnable\n    and are non-refundable; therefore, after signing for the above kit items, the student will be responsible for the documented cost of the bundled\n    books and supplies. <strong>*Retail cost may vary depending on vendor. Retail cost is product only and does not include applicable sales tax\n    or shipping and handling charges. Bellus Academy is not responsible for changes in vendor pricing or availability.</strong>",
    text2: "<strong>I understand that my Total Kit and Program Fees Amounts will be adjusted by the Total Opt-Out Amount and shown on the attached\n    Enrollment Agreement.</strong>",
    constants: {
        state: "California",
        program: "Barbering/Cosmetology 102",
        locations: {
            direction: "13266 Poway Road, Poway, CA 92064",
            phone: "Chula Vista, CA 91950",
            website: "<a href=\"https://www.bellusacademy.edu\" rel=\"noreferrer\">www.bellusacademy.edu</a>"
        }
    },
    campusesProgramList: {
        California: {
            "Barbering/Cosmetology 102": [
                {
                    item: "Financial Literacy Book",
                    size: "",
                    isbn: null,
                    vendor: "Bellus Academy",
                    bellusCost: 10.42,
                    retailCost: 12.07,
                    optOut: "yes",
                    optAmmount: 10.42,
                    sizeType: SIZE_TYPE_CONSTANTS.noneType
                },
                {
                    item: "Bellus T-Shirt (Qty: 5)",
                    size: "M",
                    isbn: null,
                    vendor: "Bellus Academy",
                    bellusCost: 43.9,
                    retailCost: 70.8,
                    optOut: "no",
                    optAmmount: 0,
                    sizeType: SIZE_TYPE_CONSTANTS.sizeType,
                    hasValidator: true
                },
                {
                    item: "Shear Set",
                    size: "",
                    isbn: null,
                    vendor: "Motik",
                    bellusCost: 43.9,
                    retailCost: 70.8,
                    optOut: "no",
                    optAmmount: 0,
                    sizeType: SIZE_TYPE_CONSTANTS.sizeType,
                    hasValidator: true
                },
                {
                    item: "Shear Set",
                    size: "Right Handed",
                    isbn: null,
                    vendor: "Motik",
                    bellusCost: 43.9,
                    retailCost: 70.8,
                    optOut: "yes",
                    optAmmount: 43.9,
                    sizeType: SIZE_TYPE_CONSTANTS.shearType,
                    hasValidator: true
                }
            ]
        }
    },
    campusesFeesList: {
        California: {
            "Barbering/Cosmetology 102": [
                {
                    item: "Pivot point LAB",
                    size: "",
                    isbn: null,
                    vendor: "",
                    bellusCost: 211.0,
                    retailCost: 0.0,
                    optOut: "",
                    optAmmount: 0
                },
                {
                    item: "Financial Literacy",
                    size: "",
                    isbn: null,
                    vendor: "",
                    bellusCost: 5.0,
                    retailCost: 0.0,
                    optOut: "",
                    optAmmount: 0
                },
                {
                    item: "Financial Literacy",
                    size: "",
                    isbn: null,
                    vendor: "",
                    bellusCost: 5.0,
                    retailCost: 134.0,
                    optOut: "",
                    optAmmount: 0
                }
            ]
        }
    },
    tableOptOutHeader: [
        { title: ["ITEM"] },
        { title: ["SIZE/TYPE"] },
        { title: ["ISBN"] },
        { title: ["VENDOR"] },
        { title: ["BELLUS COST"] },
        { title: ["RETAIL COST*"] },
        { title: ["OPT-OUT", " YES/NO"] },
        { title: ["OPT-OUT", "AMOUNT"] }
    ],
    keyRowObjects: [
        "item",
        "size",
        "isbn",
        "vendor",
        "bellusCost",
        "retailCost",
        "optOut",
        "optAmmount"
    ],
    footer: {
        published: "Published: " + helper_1.getFormatDateNow(),
        startPage: "2",
        endPage: "2"
    }
};
exports.OPT_OUTS = OPT_OUTS;
var TABLE_TYPE = ["opt-out", "opt-out-fee"];
exports.TABLE_TYPE = TABLE_TYPE;
var ENROLLMENT_AGREEMENT_FORM = {
    title: "Bellus Academy",
    subtitle1: "ENROLLMENT AGREEMENT",
    subtitle2: "All instruction will be provided at the campus location shown on this document, unless otherwise stated on a Change of Location Disclosure.",
    location: {
        website: '<a href="https://www.bellusacademy.edu/" rel="noreferrer">www.bellusacademy.edu</a>'
    },
    days: ["M", "T", "W", "TH", "F", "S"],
    itemization: [
        { label: "* Program Fees", required: true, unique: "program_fees" },
        { label: "* Tuition", required: true, unique: "tuition_cost" },
        { label: "Discounts", required: false, unique: "discounts" },
        {
            label: "Credit for Transferred Hours (See attached credit transfer forms",
            required: false,
            unique: "transfered_hours_1"
        },
        { label: "* Kit (includes books/supplies equipment)", required: true, unique: "kit" },
        { label: "Less Opt-Out Items TOTAL", required: true, unique: "opt_out_total" },
        {
            label: "Student Tuition Recovery Fund (STRF) (Non-Refundable)",
            required: true,
            unique: "strf"
        }
    ],
    itemizationTotals: [
        {
            label: "* TOTAL CHARGES FOR THE CURRENT PERIOD OF ATTENDANCE ESTIMATED",
            required: true,
            unique: "total_charges"
        },
        {
            label: "* TOTAL CHARGES FOR THE ENTIRE EDUCATIONAL PROGRAM TOTAL",
            required: true,
            unique: "total_program",
            hasDouble: true
        },
        {
            label: "* TOTAL CHARGES THE STUDENT IS OBLIGATED TO PAY UPON ENROLLMENT",
            required: true,
            unique: "total_enrollment"
        }
    ],
    annuals: [
        {
            label: "ANNUAL PERCENTAGE RATE",
            description: "The cost of your credit as a yearly rate.",
            required: true,
            unique: "percentageRate",
            hasDouble: true
        },
        {
            label: "FINANCE CHARGE",
            description: "The dollar amount the credit will cost you.",
            required: true,
            unique: "financeCharge"
        },
        {
            label: "AMOUNT FINANCED",
            description: "The Amount of credit provided to you or on your behalf.",
            required: true,
            unique: "creditsSteps"
        },
        {
            label: "TOTAL OF PAYMENTS",
            description: "The amount you will have paid after you have made all payment as scheduled.",
            required: true,
            unique: "totalPayments"
        },
        {
            label: "TOTAL SALES PRICE",
            description: "The Total Cost of your purchase on credit",
            required: true,
            unique: "downPayments"
        }
    ],
    signatures: [
        {
            title: "Signature of Applicant",
            id: "student_signature",
            className: "form-user-student",
            type: "form-signature-student"
        },
        {
            title: "Bellus Academy Admissions Representative",
            id: "school_signature",
            className: "form-user-school_official_2",
            type: "form-signature-school_official_2"
        },
        {
            title: "Signature of Spouse/Parent/Guardian",
            id: "other_signature",
            className: "form-user-student",
            type: "form-signature-school_official"
        }
    ],
    footer: {
        title: "BE SURE TO READ ALL PAGES OF THIS AGREEMENT. IT IS PART OF YOUR CONTRACT WITH BELLUS ACADEMY.",
        subtitle: "Revision Date: April 1, 2022",
        startPage: "1",
        endPage: "5"
    }
};
exports.ENROLLMENT_AGREEMENT_FORM = ENROLLMENT_AGREEMENT_FORM;
var SIZE_ARRAY = [1, 2, 3];
exports.SIZE_ARRAY = SIZE_ARRAY;
var REFUND_POLICY_CALIFORNIA = {
    title: "Institutional Refund Policy",
    studentCancel: {
        title: "STUDENT'S RIGHT TO CANCEL",
        points: [
            {
                description: [
                    "A student has the right to cancel his or her agreement for a program of instruction and receive a full refund through attendance at the first class session, or the seventh calendar day after enrollment, whichever is later."
                ]
            },
            {
                description: [
                    "After the end of the cancellation period, you also have the right to stop school at any time; and you have the right to receive a pro-rata refund if you have completed sixty (60) percent or less of the program. Changes to programs, i.e. Drops and/or Adds, can only be made during the first 7 calendar days of the program."
                ]
            },
            {
                description: [
                    "Cancellation may occur when the student provides a written notice of cancellation at the following address:",
                    ,
                    ". This can be done by mail, FAX, email or by hand delivery."
                ]
            },
            {
                description: [
                    "The cancellation date will be determined by the postmark on written notification, or the date said information is delivered to the academy in person."
                ]
            },
            {
                description: [
                    "The written notice of cancellation need not take any particular form and, however expressed, it is effective if it shows that the student no longer wishes to be bound by the Enrollment Agreement."
                ]
            },
            {
                description: [
                    "If the Enrollment Agreement is cancelled, within 45 days after the notice of cancellation is received, the academy will refund the student any money he/she paid, less any deduction for equipment that the student has received and signed for."
                ]
            }
        ]
    },
    studentCancel_Manhattan: {
        points_Manhattan: [
            {
                description: [
                    "A student has the right to cancel his or her agreement for a program of instruction and receive a full refund within three (3) business days of signing the Enrollment Agreement regardless of whether the student has actually started training."
                ]
            },
            {
                description: [
                    "After the end of the cancellation period, you also have the right to stop school at any time; and you have the right to receive a pro-rata refund if you have completed less than sixty (60) percent of the program. Changes to programs, i.e. Drops and/or Adds, can only be made during the first 7 calendar days of the program."
                ]
            },
            {
                description: [
                    "Cancellation may occur when the student provides a written notice of cancellation at the following address:",
                    ,
                    ". This can be done by mail, FAX, email or by hand delivery."
                ]
            },
            {
                description: [
                    "The cancellation date will be determined by the postmark on written notification, or the date said information is delivered to the academy in person."
                ]
            },
            {
                description: [
                    "The written notice of cancellation need not take any particular form and, however expressed, it is effective if it shows that the student no longer wishes to be bound by the Enrollment Agreement."
                ]
            },
            {
                description: [
                    "If the Enrollment Agreement is cancelled after three (3) business days of signing, but prior to starting classes, the academy will refund the student any money he/she paid, within 45 days after the notice of cancellation is received."
                ]
            }
        ]
    },
    withdrawFrom: {
        title: "WITHDRAWAL FROM THE PROGRAM",
        description1: "You may withdraw from the academy at any time after the cancellation period (described above) and receive a pro-rata refund within 45 days of withdrawal\n        if you have completed 60 percent or less of the period of attendance, based on scheduled hours. The refund will be less any deduction for equipment\n        that the student has received and signed for.",
        description2: "For the purpose of determining a refund under this section, a student\u2019s official cancellation or withdrawal shall occur on the earlier of the dates of any of\n        the following instances:",
        points1: [
            "An applicant is not accepted by the academy. The applicant shall be entitled to a refund of all monies paid.",
            "The student notifies the institution of the student\u2019s withdrawal in writing.",
            "The institution terminates the student\u2019s enrollment for failure to maintain satisfactory progress; failure to abide by the rules and regulations of\n            the institution; absence in excess of maximum set forth by the institution; and/or failure to meet financial obligations to the academy.",
            "The student has failed to attend class for fourteen (14) calendar days, as determined by monitoring clock hour attendance at least every thirty\n            (30) days.",
            "Failure to return from a leave of absence. The date of the student\u2019s withdrawal shall be the earlier of the scheduled date of return from the\n            leave of absence or the date the student notifies the institution that the student will not be returning."
        ]
    },
    footer: {
        title: "BE SURE TO READ ALL PAGES OF THIS AGREEMENT. IT IS PART OF YOUR CONTRACT WITH BELLUS ACADEMY.",
        subtitle: "Revision Date: February 8, 2021",
        startPage: "2",
        endPage: "5"
    }
};
exports.REFUND_POLICY_CALIFORNIA = REFUND_POLICY_CALIFORNIA;
var REFUND_POLICY_CALIFORNIA_2 = {
    withdrawFrom: {
        points2: [
            "Provide a pro-rata refund for all students transferring to another school based on the hours accepted by the\n            receiving school; or",
            "Provide completion of the program; or",
            "Participate in a Teach-Out Agreement; or",
            "Provide a full refund of all monies paid"
        ]
    },
    footer: {
        title: "BE SURE TO READ ALL PAGES OF THIS AGREEMENT. IT IS PART OF YOUR CONTRACT WITH BELLUS ACADEMY.",
        subtitle: "Revision Date: February 8, 2021",
        startPage: "3",
        endPage: "5"
    }
};
exports.REFUND_POLICY_CALIFORNIA_2 = REFUND_POLICY_CALIFORNIA_2;
var UNDERSTANDING = {
    title: "Understandings",
    tableConditions: [
        {
            subtitle: "Catalog: ",
            description: [
                "Information about Bellus Academy is published in an academy catalog that contains a description of certain policies, procedures, and other information about the academy. Bellus Academy reserves the right to change any provision of the catalog\n            at any time. Notice of changes will be communicated in a revised catalog, an addendum or supplement to the catalog, or other written format. Students are expected to read and be familiar with the information contained in the academy catalog, in any revisions, supplements and addenda to the catalog, and with all academy policies. By enrolling in Bellus Academy, the Student agrees to abide by the terms stated in the catalog and all academy policies"
            ]
        },
        {
            subtitle: "Elimination of Classes: ",
            description: [
                "Bellus Academy reserves the right to cancel or postpone a scheduled class start\n            when the number of students scheduled to start the program is not sufficient as determined by Bellus\n            Academy. If the student does not choose to change to a different start date, the student will be eligible for a\n            full refund."
            ]
        },
        {
            subtitle: "Students with Disabilities: ",
            description: [
                "Bellus Academy does not discriminate on the basis of disability in admission\n            or access to its programs, services, or activities of individuals who meet essential eligibility requirements.\n            Bellus Academy will provide reasonable accommodations for documented disabilities of individuals who are\n            eligible to receive or participate in academy programs, services, or activities. If you require accommodations,\n            please contact the Academy Director / Manager prior to signing this Enrollment Agreement in order to create a\n            reasonable academic plan."
            ]
        },
        {
            subtitle: "Disclosure of Schedule, Dates, Location Changes: ",
            description: [
                "I understand that I may be required to sign\n            additional Disclosures, depending on the program I am enrolled in, to acknowledge there may be changes to\n            my scheduled hours, changes to dates that sections of the program are offered, and/or changes to the location\n            at which the program or sections of the program are offered. Such Disclosures are incorporated into and made\n            a part of this Agreement by this reference."
            ]
        },
        {
            subtitle: "Failure to maintain passing grades: ",
            description: [
                "Failure to abide by the rules and regulations of the institution;\n            absences in excess of maximum set forth by the institution; and/or failure to meet financial obligations to the\n            academy. Students who exceed the Maximum Time Frame allowed to complete the program (133% of weeks\n            and/or hours) will be dropped from the program"
            ]
        },
        {
            subtitle: "Transfer of Clock Hours: ",
            description: [
                "The awarding of credit for clock hours completed at any other institution is at\n            the sole discretion of Bellus Academy. Additionally, Bellus Academy does not imply, promise, or guarantee\n            that any credits earned at Bellus Academy will be transferable or accepted by any other institution."
            ]
        },
        {
            subtitle: "Diplomas and Certificates: ",
            description: [
                "I understand that Students are issued a Diploma upon completion of\n            programs leading to State or National licensing, or a Certificate, upon completion of programs that do not lead\n            to licensure, evidencing graduation and satisfactory completion of the required clock hours. Students are\n            eligible for graduation, providing they maintain a satisfactory grade in theory and clinical classes, have\n            completed all assigned projects, and either have paid their tuition in full or have entered into a payment plan\n            agreement for payment of tuition. They must also have been in attendance for the required amount of clock\n            hours as set forth in the course of instruction. There is a $5 fee for each request for a duplicate diploma."
            ]
        },
        {
            subtitle: "Financing: ",
            description: [
                "The Student understands that if a separate party is financing his/her education, that the\n            Student, and the Student alone, is directly responsible for all payments and monies owed to the academy\n            listed on this agreement."
            ]
        },
        {
            subtitle: "Assignment of Debt: ",
            description: [
                "The student hereby grants permission to Bellus Academy to assign, transfer or\n            convey to a loan servicing company any balance due to Bellus Academy after their last day of attendance.\n            Such company will accept and assume the balance of the student's debt, and the student will be responsible\n            for repaying the debt and any fees assessed directly to the loan servicing company."
            ]
        },
        {
            subtitle: "Overtime Charges: ",
            description: [
                "Students are allowed to miss 7.5% of the total hours contracted without being\n            charged Overtime. Overtime occurs when a student has not completed their program of study by the\n            enrollment agreement end date. If training is not completed within the prescribed time limit, additional tuition\n            fees will accrue at the hourly rate stated on this contract until the time the student meets the graduation\n            requirements. Students must meet with Financial Aid to determine a payment plan at the time that overtime\n            charges begin to accrue."
            ]
        },
        {
            subtitle: "Placement Assistance: ",
            description: [
                "Placement assistance may be provided. However, it is understood that the\n            academy does not and cannot promise or guarantee employment or level of income or wage rate to any\n            Student or graduate."
            ]
        },
        {
            subtitle: "Supplies/Equipment: ",
            description: [
                "All supplies for the program selected will be provided by the academy at the\n            stated charge. Lost, mutilated, or stolen items will be replaced at the expense of the student. If lost or stolen,\n            students may purchase a new ID badge for $5."
            ]
        },
        {
            subtitle: "Loan: ",
            description: [
                "If a student is eligible for a loan guaranteed by the federal or state government and the student\n            defaults on the loan, both of the following may occur: A. The federal or state government or a loan guarantee\n            agency may take action against the student, including applying any income tax refund to which the person is\n            entitled to reduce the balance owed on the loan. B. The student may not be eligible for any other federal\n            student financial aid at another institution or other government assistance until the loan is repaid."
            ]
        },
        {
            subtitle: "NOTICE CONCERNING TRANSFERABILITY OF CREDITS AND CREDENTIALS EARNED AT OUR INSTITUTION: ",
            description: [
                "The transferability of credits you earn at Bellus Academy is at the complete discretion of an\n            institution to which you may seek to transfer. Acceptance of the Diploma or Certificate you earn in",
                "",
                "program is also at the complete discretion of the institution to\n            which you may seek to transfer. If the diploma/certificate that you earn at this institution is not accepted at\n            the institution to which you seek to transfer, you may be required to repeat some or all of your coursework at\n            that institution. For this reason, you should make certain that your attendance at this institution will meet\n            your educational goals. This may include contacting an institution to which you may seek to transfer after\n            attending Bellus Academy to determine if your credits, diploma or certificate will transfer."
            ]
        },
        {
            subtitle: "Questions: ",
            description: [
                "Any questions a student may have regarding this enrollment agreement that have not been satisfactorily answered by the institution may be directed to the Bureau for Private Postsecondary Education, P.O. Box 980818, Sacramento, CA 95798-0818, www.bppe.ca.gov, (888) 370-7589 (toll free)."
            ]
        },
        {
            subtitle: "Complaint: ",
            description: [
                "A student or any member of the public may file a complaint about this institution with the Bureau for Private Postsecondary Education by calling (888) 370-7589 (toll free) or by completing a complaint form, which can be obtained on the Bureau\u2019s Internet Web site, www.bppe.ca.gov."
            ]
        }
    ],
    manhatanConditions: [
        {
            subtitle: "Questions: ",
            description: [
                "Any questions a student may have regarding this enrollment agreement that have not been satisfactorily answered bythe institution may be directed to the Kansas Board of Barbering, 700 SW Jackson St., Ste. 1002, Topeka, KS 66603, 785-296-2211, www.kbob.kansas.gov; Kansas Board of Cosmetology, 714 SW Jackson, Suite 100, Topeka, KS 66603, 785-296-3155,www.accesskansas.org; or the Kansas Board of Regents, 1000 SW Jackson St., Suite 100, Topeka, KS 66612, 785-296-3421,www.kansasregents.org."
            ]
        },
        {
            subtitle: "Complaint: ",
            description: [
                " A student or any member of the public may file a complaint about this institution with the Kansas Board of Barbering,700 SW Jackson St., Ste. 1002, Topeka, KS 66603, 785-296-2211, www.kbob.kansas.gov; Kansas Board of Cosmetology, 714 SW Jackson, Suite 100, Topeka, KS 66603, 785-296-3155, www.accesskansas.org; or the Kansas Board of Regents, 1000 SW Jackson St.,Suite 100, Topeka, KS 66612, 785-296-3421, www.kansasregents.org, or by completing a complaint form, which can be obtained on the Boards\u2019 Internet Web sites."
            ]
        }
    ],
    newCondition: [
        {
            subtitle: "Distance Education Technology Requirements: ",
            description: [
                "Hardware: Access to a Windows\u00AE/MacOSTM/iOS; Internet access either via\n                modem and phone line or high speed BROADBAND access; Internet service provider for home/work access; e-mail account for\n                sending and receiving electronic email; applicable browser for internet access; ability to video conference in real time\n                (appropriate equipment required - camera, microphone, etc) Software: Microsoft Word compatible and/or RTF (Rich Text\n                Format); Download and install the following software (or comparable alternatives): Adobe Acrobat Reader, Bellus Academy\n                App, CourseKey App; Optional: Antivirus Software."
            ]
        }
    ],
    footer: {
        title: "BE SURE TO READ ALL PAGES OF THIS AGREEMENT. IT IS PART OF YOUR CONTRACT WITH BELLUS ACADEMY.",
        subtitle: "Revision Date: February 8, 2021",
        startPage: "4",
        endPage: "5"
    }
};
exports.UNDERSTANDING = UNDERSTANDING;
var NOTICE = {
    title: "Notice",
    description1: "YOU MAY ASSERT AGAINST THE HOLDER OF THE PROMISSORY NOTE YOU SIGNED IN ORDER TO FINANCE THE COST OF THE\n    EDUCATION PROGRAM ALL OF THE CLAIMS AND DEFENSES THAT YOU COULD ASSERT AGAINST THIS INSTITUTION, UP TO THE\n    AMOUNT YOU HAVE ALREADY PAID UNDER THE PROMISSORY NOTE.",
    description2: "Prior to signing this enrollment agreement, you must be given a catalog or brochure and a School Performance Fact Sheet, which\n    you are encouraged to review prior to signing this agreement. These documents contain important policies and performance data for\n    this institution. This institution is required to have you sign and date the information included in the School Performance Fact Sheet\n    relating to completion rates, placement rates, license examination passage rates, salaries or wages, and the most recent three-year\n    cohort default rate, if applicable, prior to signing this agreement.",
    description3: "I certify that I have received the catalog, School Performance Fact Sheet, and information regarding completion rates, placement\n    rates, license examination passage rates, salary or wage information, and the most recent three-year cohort default rate, if\n    applicable, included in the School Performance Fact sheet, and have signed, initialed, and dated the information provided in the\n    School Performance Fact Sheet.",
    footer: {
        title: "BE SURE TO READ ALL PAGES OF THIS AGREEMENT. IT IS PART OF YOUR CONTRACT WITH BELLUS ACADEMY.",
        subtitle: "Revision Date: February 8, 2021",
        startPage: "5",
        endPage: "5"
    }
};
exports.NOTICE = NOTICE;
//# sourceMappingURL=data:application/json;base64,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